// Split out of the single MESSAGES object so that only the active locale
// ships in the entry chunk. Keys must stay in step across all three.

export const PT_BR = {
  registerByPhone: 'Telefone',
  registerByEmail: 'E-mail',
  authSocialDivider: 'Ou entre com',
  googleContinue: 'Continuar com Google',
  googleCompleteChecks: 'Aceite os termos e conclua a verificação para continuar.',
  googleEmailExists: 'Este e-mail já tem uma conta. Entre com sua senha ou com um código por e-mail.',
  googleFailed: 'Não foi possível entrar com Google. Tente novamente.',
  googleRetry: 'Tentar novamente',
  accessMode: 'Modo de acesso',
  active: 'MOVIMENTADA',
  all: 'Todas',
  authAccountNotFound: 'Conta não encontrada',
  authPasswordIncorrect: 'Senha incorreta',
  authError: 'Falha ao entrar',
  authForgotFail: 'Falha · tente novamente',
  authOtpNoUsername: 'Códigos só são enviados ao e-mail ou telefone — não ao usuário.',
  phoneHintMissingDDD: 'Inclua o DDD (ex: (11) 91234-5678).',
  phoneHintShort: '%n%/11 dígitos',
  phoneHintBadDDD: 'DDD inválido',
  phoneHintMobile9: 'Celulares precisam começar com 9 após o DDD',
  phoneHintNeedsMobile: 'O cadastro precisa de um número de celular — este parece ser um fixo',
  authOtpFail: 'Falha ao enviar · tente novamente',
  authPreparing: 'Preparando sua sessão...',
  authPwdReset: 'Senha alterada · faça login',
  authLoginFail: 'Conta ou senha incorretos',
  authPhoneTaken: 'Telefone já cadastrado',
  authEmailTaken: 'E-mail já cadastrado',
  authInviteInvalid: 'Código de convite inválido',
  authOtpExpired: 'Código expirou. Envie um novo.',
  authSigningIn: 'Entrando...',
  authCreatingAccount: 'Criando conta...',
  authSendingOtp: 'Enviando código...',
  authResettingPwd: 'Redefinindo senha...',
  authAccountCreated: 'Conta criada',
  errIdentifierInvalid: 'Digite um telefone ou e-mail válido.',
  errInvalidPhone: 'Telefone inválido — digite seu celular completo',
  errOtpDemo: 'Código inválido ou expirado',
  errOtpInvalid: 'Código inválido ou expirado. Peça um novo código e tente de novo.',
  errCountryNotSupported: 'Este país não está disponível no momento. Escolha um país habilitado.',
  errOtpSmsUnavailable: 'O envio de SMS está temporariamente indisponível. Tente novamente em instantes.',
  errOtpRateLimited: 'Muitas tentativas — aguarde um pouco antes de tentar de novo.',
  errChannelNotVerified: 'Este contato não está verificado. Verifique primeiro ou fale com o suporte.',
  errNoVerifiedChannel: 'Você não tem nenhum contato verificado. Fale com nosso suporte.',
  hidePwd: 'Ocultar senha',
  demoNote: 'Use seu telefone e senha para entrar.',
  authOtpLoginFail: 'Código inválido ou expirado.',
  authWelcome: 'Bem-vindo de volta',
  acceptingBets: 'Apostas abertas',
  amount: 'Valor',
  backToLogin: 'Voltar',
  backToLobby: 'Voltar ao lobby',
  balance: 'Saldo',
  betFailed: 'Não foi possível apostar',
  sessionExpired: 'Sessão expirada — entre novamente',
  betRateLimited: 'Muitas apostas — aguarde um instante',
  betPrevRoundDrawing: 'Sorteando a rodada anterior — abre já',
  betPreviousSettlementWaiting: 'Aguardando liquidação anterior',
  betPreviousSettlementNotice: 'Uma rodada anterior ainda está em sorteio ou liquidação. Você pode apostar com o saldo disponível; o retorno será creditado após a liquidação.',
  betInsufficientBalance: 'Saldo insuficiente',
  betLimitExceeded: 'Limite da rodada excedido',
  betPlaced: 'Aposta enviada',
  bets: 'apostas',
  betsCloseIn: 'Apostas fecham em',
  betsLocked: 'Apostas bloqueadas',
  locked: 'FECHADO',
  waitingBlock: 'Aguardando bloco',
  computingResult: 'Calculando resultado',
  calm: 'TRANQUILA',
  chat: 'Chat',
  chatEmpty: 'Nenhuma mensagem ainda',
  chatComingSoon: 'Chat em breve',
  chatLoadError: 'Falha ao carregar chat',
  chatMuted: 'Chat temporariamente bloqueado',
  chatPlaceholder: 'Digite uma mensagem…',
  chatPreview: 'Mensagens da sala',
  chatSendError: 'Não foi possível enviar',
  choosePick: 'Escolha uma opção',
  chipYou: 'VOCÊ',
  tickerBet: '💰 %name% · %amount% · %pick%',
  sheetRoomBets: 'Apostas da sala',
  sheetHistory: 'Histórico',
  skeletonLoading: 'Entrando na sala…',
  betFabHintTitle: 'Arraste para o outro lado',
  betFabHintSub: 'toque para apostar',
  clear: 'Limpar',
  clearAll: 'Limpar tudo',
  close: 'Fechar',
  trustStrip: 'O sorteio é à vista de todos',
  drag: 'arraste',
  rulesForkNote: 'Nota para quem confere rodadas antigas: até 29/04/2026 12:35 UTC, os 3 blocos âncora podiam cair dentro da própria rodada. Desde então, são sempre os 3 primeiros blocos APÓS o fechamento das apostas. Ao verificar uma rodada, use a regra vigente na data dela.',
  vipRule: 'Cada R$ 1 apostado vale 1 ponto. Seu nível nunca cai.',
  vipFaltam: 'Faltam %v% para o VIP %n%',
  vipSalasTitle: 'Salas que seu nível abre',
  vipSalasNote: 'Seu nível VIP abre as salas. O cashback de cada sala aparece na própria sala.',
  vipTotalDeposited: 'Depositado',
  vipShortInBets: 'em apostas',
  vipShortInDeposits: 'em depósitos',
  vipNextLevelUnlocks: 'VIP %n% abre as salas %tier%.',
  vipNextLevelNothing: 'VIP %n% não abre nada novo — o próximo desbloqueio é %tier%, no VIP %at%.',
  vipNextLevelNothingPlain: 'VIP %n% não abre nenhuma sala nova.',
  vipUnlockAt: 'Libera no VIP %n%',
  vipUnlocked: 'Liberada',
  vipAllLevels: 'Ver todos os níveis',
  vipSalaEntry: 'Entrada liberada',
  vipFaltamShort: 'Faltam %v%',
  vipNextUnlockTitle: 'Próximo desbloqueio',
  vipNextUnlockAt: 'No VIP %n%',
  vipYouAreHere: 'Você está aqui',
  vipPerksNowTitle: 'Seus benefícios agora',
  vipPerkRooms: 'Salas até %b%',
  vipNextLevels: 'Próximos níveis',
  vipPerkTickets: 'Bilhetes',
  drumRaffleTitle: 'Sorteio das %h%',
  drumPrizes: 'R$ %n% em prêmios',
  drumEntries: '%n% de %m% inscritos',
  drumFaltam: 'faltam %n% min',
  drumJoin: 'Participar',
  confirmPasswordLabel: "Confirmar senha",
  passwordsMismatch: "As senhas não coincidem",
  verificationRetry: "Falha na verificação. Toque para tentar novamente.",
  verificationLoading: "Carregando verificação…",
  registerSub: "Crie sua conta com uma senha.",
  forgotSub: 'A gente te envia um código para criar uma senha nova.',
  otpNoAccount: 'Esse e-mail ou celular ainda não tem conta.',
  otpChecking: 'Verificando sua conta…',
  otpSentTo: 'Código enviado para %id%',
  resendInSec: 'Reenviar em %n%s',
  howEx_ld_oddeven: 'Ex.: R$ 10 no ÍMPAR → sai 7 → você recebe R$ 20.',
  howEx_ld_bigsmall: 'Ex.: R$ 10 no ALTO (5–9) → sai 8 → você recebe R$ 20.',
  howEx_ld_specific: 'Ex.: R$ 10 no número 7 → sai 7 → você recebe R$ 95.',
  howEx_sicbo_bs: 'Ex.: R$ 10 no ALTO (11–17) → soma 14 → você recebe R$ 19,50.',
  howEx_sicbo_sum: 'Ex.: R$ 10 na soma 10 → sai 10 → você recebe R$ 70 (×7).',
  howEx_rou_rb: 'Ex.: R$ 10 no VERMELHO → sai 23 (vermelho) → você recebe R$ 19,50. Zero perde.',
  howEx_rou_oe: 'Ex.: R$ 10 no PAR → sai 12 → você recebe R$ 19,50. Zero perde.',
  howEx_rou_hilo: 'Ex.: R$ 10 no 19–36 → sai 25 → você recebe R$ 19,50. Zero perde.',
  howEx_rou_num: 'Ex.: R$ 2 no número 17 → sai 17 → você recebe R$ 72 (×35).',
  howEx_sicbo_single: 'Ex.: R$ 10 no dado 3 → sai um 3 → R$ 20 · dois 3 → R$ 30 · três 3 → R$ 60.',
  howEx_sicbo_combo: 'Ex.: R$ 10 em 2 e 5 → os dados mostram 2 e 5 → você recebe R$ 65.',
  howEx_sicbo_pairs: 'Ex.: R$ 10 na dupla 3-3 → saem dois 3 → você recebe R$ 120.',
  sicboPairsHelp: 'Dupla = dois dados iguais · Trinca = três dados iguais.',
  caUse: 'Usar este valor',
  ageGateTitle: 'Só para maiores de 18 anos',
  ageGateBody: 'O Sorteia é um jogo com dinheiro real. Jogue com responsabilidade — e só se você tiver 18 anos ou mais.',
  ageGateConfirm: 'Tenho 18 anos ou mais',
  liveNow: 'Ao vivo agora',
  liveShort: 'AO VIVO',
  drawEvery5: 'sorteio a cada 5 min',
  soulQuote: '\u201cNão prometemos que você vai ganhar. Prometemos que o jogo é justo.\u201d',
  ultimosLabel: 'Últimos',
  podeConferir: 'Pode conferir',
  heroTitle: 'Ninguém mexe no resultado — nem a gente.',
  heroPublic: 'Sorteio público',
  heroPix: 'Pix na hora',
  heroPixNoPix: 'Saque em até 1 hora',
  heroCheck: 'Você confere',
  landingSub: 'Sorteio público a cada 5 minutos. O prêmio cai no Pix na hora. E você confere sozinho.',
  landingSubNoPix: 'Sorteio público a cada 5 minutos. O prêmio cai direto na sua conta. E você confere sozinho.',
  seeRooms: 'Ver as salas',
  howToPlay: 'Como jogar?',
  howWhat_ld: 'Aposte no último dígito do sorteio (0–9): par/ímpar, alto/baixo ou o número exato.',
  howWhat_sicbo: 'Três dados a cada rodada: aposte em Alto (11–17), Baixo (4–10), na soma exata, em duplas ou trincas.',
  howWhat_rou: 'Uma casa de 0 a 36: vermelho/preto, par/ímpar, alto/baixo ou o número exato.',
  howSource: 'O resultado sai de um sorteio público que ninguém pode alterar — nem a gente. Cada rodada é independente.',
  howPay_ld: 'Par/ímpar e alto/baixo pagam ×2 (0 e 9 pagam ×1,5) · número exato paga ×9,5.',
  howPay_sicbo: 'Alto/Baixo ×1,95 · soma exata até ×62 · trinca específica ×180.',
  howPay_rou: 'Cores, par/ímpar e alto/baixo ×1,95 (zero perde) · número exato ×35.',
  howStep1: 'Comece com R$ 2 — escolha um número ou uma aposta simples.',
  howStep2: 'O sorteio é público, a cada 5 minutos. Ninguém controla o resultado — e você pode conferir quando quiser.',
  howStep3: 'Ganhou? O prêmio cai na sua conta na hora, via Pix.',
  howItWorksBar: 'Como funciona · 3 passos',
  howClose: 'Entendi',
  fullRules: 'Regras completas',
  viewAllDraws: 'Ver todos os sorteios',
  complyLine: 'Jogo Responsável · Pix · Sorteio justo',
  complyLineNoPix: 'Jogo Responsável · Sorteio justo',
  betsNowOne: 'aposta nesta rodada',
  betsNowMany: 'apostas nesta rodada',
  peopleNowOne: 'pessoa agora',
  peopleNowMany: 'pessoas agora',
  collapseUtilityCards: '↑ recolher',
  comingSoon: 'Em breve',
  confirmBet: 'CONFIRMAR APOSTA',
  confirmBets: 'Confirmar apostas',
  copy: 'Copiar',
  copyFailed: 'Não foi possível copiar · selecione manualmente',
  copySucceeded: 'Copiado!',
  createAccount: 'Criar sua conta',
  createAccountAction: 'Criar conta',
  currentRound: 'Rodada',
  roomHeaderPool: 'pote',
  enterAccount: 'Entrar na conta',
  enterRoom: 'Entrar na sala',
  enterToPlay: 'Entre para jogar',
  enterToChat: 'Entre para conversar',
  expandUtilityCards: 'Mostrar regras e histórico',
  filterPlayable: 'Posso entrar',
  filterRooms: 'Filtrar salas',
  forgotAction: 'Recuperar senha',
  forgotPwdInline: 'Esqueceu a senha?',
  forgotWelcome: 'Recuperar senha',
  brandHeadline: 'Aposte sem desconfiar.',
  brandSubline: 'O sorteio é público, a cada 5 minutos. Ganhou? Pix na hora.',
  brandTrust1: 'Sorteio à vista',
  brandTrust2: 'A cada 5 min',
  brandTrust3: 'Pix instantâneo',
  socialProof: '120 mil brasileiros já confiam no Sorteia',
  poweredBy: 'Cada sorteio fica registrado em público — para sempre',
  noAccountQ: 'Não tem conta?',
  agreeTermsLink: 'Termos',
  identifierTip: 'Confirme que o e-mail ou telefone está correto — é por aí que você recupera sua conta.',
  phoneTip: 'Confirme que o número está correto — é para lá que enviamos o código.',
  registerCountryField: 'País / região',
  registerCountryPickerLabel: 'País e código do país',
  registerCountryDetected: 'Detectado pela sua conexão',
  registerCountryLabel: 'Você está criando conta em',
  registerCountryCurrency: 'Moeda',
  registerCountryImmutable: 'Não pode ser alterado depois',
  registerCountryUnverified: 'Não conseguimos confirmar seu país agora. Confira antes de continuar — isso não pode ser alterado depois.',
  loginConsentLine: 'Ao entrar você confirma ter 18+ e aceitar os {terms}.',
  roulTableTab: 'Mesa',
  rouQEditEdit: 'Editar posição',
  rouQEditPlaced: 'Feita (bloqueada)',
  rouQEditClear: 'Limpar pendentes',
  rouQEditRoundTotal: 'Rodada',
  rouQEditPending: 'Pendente',
  todayCount: '%n% hoje',
  game_lastdigit: 'Último Dígito',
  game_sicbo: 'Sic Bo',
  game_roulette: 'Roleta',
  game_milhar: 'Milhar',
  game_milhar_hora: 'Milhar da Hora',
  game_unknown: 'Jogo desconhecido',
  milharTitle: 'Milhar',
  milharLobbyBadge: 'A CADA 5 MIN',
  milharTier4Cadence: 'A cada 5 min · 4 dígitos',
  milharTier5Title: 'Milhar da Hora',
  milharTier5Cadence: 'A cada hora · 5 dígitos',
  milharTier6Title: 'Milhar do Dia',
  milharTier6Cadence: 'Todo dia · 6 dígitos',
  milharTierSoon: 'EM BREVE',
  milharTierSoonHint: 'Prêmio maior, sorteio mais difícil. Ainda não disponível.',
  milharPoolLabel: 'ACUMULADO',
  milharPoolRounds: 'já são %n% rodadas acumulando',
  milharPickPrompt: 'Escolha %d% dígitos',
  milharSurpresinha: 'Surpresinha',
  milharClear: 'Limpar',
  milharRoundsPrompt: 'Por quantas rodadas?',
  milharTeimosinha: 'Teimosinha',
  milharTeimosinhaHelp: 'Você joga o mesmo número nas próximas rodadas, sem precisar apostar de novo. O valor é debitado agora, de uma vez.',
  milharQtyPrompt: 'Quantas apostas?',
  milharSummary: '%q% %qu% × %r% %ru%',
  milharUnitBet: 'aposta',
  milharUnitBets: 'apostas',
  milharUnitRound: 'rodada',
  milharUnitRounds: 'rodadas',
  milharMaduroBadge: 'MADURO',
  milharMaduroMain: '%n% dígitos já levam o pote',
  milharMaduroSub: 'Chance 10x maior',
  milharHowIntro: 'Você escolhe %d% dígitos. %c% Compare da direita para a esquerda — quanto mais dígitos você acertar, maior o prêmio.',
  milharHowDraw4: 'Sorteio a cada 5 min.',
  milharHowDraw5: 'Sorteio a cada hora.',
  milharHowDraw6: 'Sorteio todo dia.',
  milharHowRow: 'Como funciona',
  milharHowPerBet: '%v% por aposta',
  milharHowS1: 'Escolha %d% dígitos. %c%',
  milharHowChip: '3 blocos → 10 dígitos',
  milharHowDerive: 'dígitos %a%–%b%',
  milharHowS2: 'Fechada a rodada, a blockchain gera 10 dígitos. %t% usa os dígitos %a%–%b%. Ninguém controla.',
  milharHowYou: 'você',
  milharHowHits: '%n% dígitos · %v%',
  milharHowHit1: '1 dígito · %v%',
  milharHowOnly: 'só %s%',
  milharHowS3: 'Conte do último dígito para trás. No primeiro erro, para: os da frente não contam.',
  milharHowVerify: 'Rodada %r% · conferir na blockchain',
  milharWinToast: 'Você ganhou %v%',
  milharResultsPageTitle: 'Resultados',
  milharTabFrequency: 'Frequência',
  milharTabGaps: 'Atrasos',
  milharMineStake: 'Apostou %v%',
  milharTabMine: 'Meus',
  milharMineEmpty: 'Você ainda não apostou em nenhuma rodada.',
  milharMineGuest: 'Entre para ver as rodadas em que você apostou.',
  milharMineSummary: '%r% rodadas · %w% ganhas · %v%',
  milharTabHistory: 'Histórico',
  milharHistRound: 'Rodada',
  milharHistResult: 'Resultado',
  milharHistTime: 'Hora',
  milharHistStaked: 'Apostas',
  milharHistJackpot: 'Acumulado levado',
  milharHistMineWon: 'Você jogou e ganhou',
  milharHistMinePlayed: 'Você jogou',
  milharHistEmpty: 'Nenhuma rodada sorteada ainda.',
  milharHistToday: 'Hoje',
  milharHistYesterday: 'Ontem',
  milharTabFair: 'Justo',
  milharStatsPosition: 'Posição',
  milharStatsPeriod: 'Período',
  milharStatsExpected: 'esperado: %e% · faixa normal: %l%–%h%',
  milharStatsNormal: 'normal',
  milharStatsOutside: 'fora da faixa',
  milharStatsFooter: 'Estes são os resultados que já saíram. O próximo não depende de nenhum anterior.',
  milharStatsGapUnit: 'rodadas atrás',
  milharStatsSample: '%n% rodadas',
  milharStatsEmpty: 'Sem resultados ainda',
  milharStatsError: 'Não foi possível carregar',
  milharStatsRetry: 'Tentar de novo',
  milharVerifyTitle: 'Como este resultado saiu',
  milharVerifyOpen: 'Conferir como a rodada %n% saiu',
  milharVerifyUnavailable: 'Não conseguimos carregar esta rodada agora.',
  milharVerifyGlobalId: 'Rodada global',
  milharVerifyResultTitle: 'Esta rodada',
  milharVerifyDigitsTitle: 'Três blocos → dez dígitos',
  milharVerifyStepsTitle: 'Faça a conta você mesmo',
  milharVerifyStep1: 'Os dez dígitos públicos desta rodada são %d%. Todos os jogos da rodada leem daqui.',
  milharVerifyStep2: 'Esta faixa pega os dígitos %a% a %b% — dá %r%, o número sorteado.',
  milharVerifyBlocksTitle: 'Os três blocos, confira você mesmo',
  milharVerifyFoot: 'Os blocos são criados depois que a rodada fecha. Ninguém consegue saber antes.',
  milharVerifyMismatch: 'Não conseguimos reproduzir este número com os dígitos públicos abaixo — o resultado mostrado acima é o registro oficial desta rodada.',
  milharWinnersTitle: 'Quem já levou',
  milharWinnerOpenProfile: 'Ver o perfil de %u%',
  milharWinnerOpenRound: 'Ver a rodada %r%',
  milharWinnerAnonymous: 'Jogador anônimo',
  milharCtaReady: 'APOSTAR %v%',
  milharCtaIncomplete: 'Escolha %d% dígitos',
  milharCtaWaiting: 'Aguardando o sorteio',
  milharCtaDeposit: 'Depositar para apostar',
  milharCtaGuest: 'Entrar para apostar',
  milharCtaUnavailable: 'Este número não está disponível nesta rodada',
  milharUnavailableHint: 'Escolha outro número ou espere a próxima rodada.',
  milharBetsTitle: 'Suas apostas',
  milharBetsEmpty: 'Você ainda não apostou nesta rodada',
  milharBetsEmptyCta: 'Escolher meu número',
  milharMoreRounds: 'e +%n%',
  milharPending: 'Aguardando resultado',
  milharWon: 'Você ganhou',
  milharLost: 'Não foi dessa vez',
  milharRefunded: 'Rodada anulada · valor devolvido',
  milharRevealTitle: 'Resultado da %r%',
  milharIndependent: 'Cada rodada é independente — números que "não saem há muito tempo" não têm mais chance.',
  milharSeed: 'Quando alguém leva, 20% do pote fica de semente para começar o próximo.',
  milharBetConfirmed: 'Aposta confirmada · %n% · %r% rodadas',
  milharBetConfirmedOne: 'Aposta confirmada · %n%',
  milharBetSheetTitle: 'Aposta confirmada!',
  milharBetSheetLuck: 'Boa sorte! Agora é só esperar o sorteio.',
  milharBetSheetDebited: 'Debitado agora',
  milharBetSheetPublic: 'Sua aposta já aparece na lista desta rodada.',
  milharBetSheetSeeBets: 'Ver minhas apostas',
  milharBetSheetAgain: 'Escolher outro número',
  milharCoPickers: 'Mais %n% pessoas escolheram este número',
  milharCoPickersHint: 'Se sair o Acumulado, vocês dividem · os outros prêmios não mudam',
  milharRoundNumbersTitle: 'Números desta rodada',
  milharRoundNumbersHint: 'Isso não muda a chance de sair — só muda com quantas pessoas você divide o Acumulado.',
  milharFeedPeople: 'pessoas nesta rodada',
  milharRoundIdLabel: 'Rodada',
  milharResultLabel: 'RESULTADO',
  milharPoolMadeOf: 'De onde vem esse prêmio',
  milharDetailStaked: 'Apostado nesta rodada',
  milharDetailPaid: 'Pago aos ganhadores',
  milharDetailToPool: 'Foi para o Acumulado',
  milharDetailToPoolShare: '%p% desta rodada',
  milharDetailGlobalId: 'Global #%n%',
  milharDetailGlobalIdCopied: 'Copiado #%n%',
  milharDetailGlobalIdSelect: 'Segure para selecionar #%n%',
  milharDetailCopyGlobalId: 'Copiar o número global da rodada',
  milharDetailWhoPlayed: 'Quem jogou nesta rodada',
  milharDetailCount: '%p% pessoas · %t% bilhetes',
  milharDetailPartial: 'Mostrando %n% de %t% bilhetes — os maiores prêmios primeiro.',
  milharLedgerColRound: 'Rodada',
  milharLedgerColChange: 'Nesta rodada',
  milharLedgerColBalance: 'Acumulado depois',
  milharDetailUnavailable: 'Não conseguimos carregar esta rodada agora.',
  milharPoolSeedCarried: 'Sobrou do sorteio %r%',
  milharPoolSeedInitial: 'Prêmio inicial da plataforma',
  milharPoolAccrued: 'Acumulado desde então',
  milharFlowStakeTitle: 'A cada rodada, para onde vai sua aposta',
  milharFlowPool: 'Acumulado',
  milharFlowFixed: 'Pago a quem acerta',
  milharFlowHouse: 'Plataforma',
  milharFlowRtp: 'A cada %base% apostados, em média %rtp% voltam para os jogadores em prêmios.',
  milharFlowRtpDetail: '%pool% entram no prêmio acumulado acima e %fixed% são pagos direto a quem acerta na rodada — a partir de um dígito final. Os %house% restantes são a receita da plataforma.',
  milharFlowBridge: 'O que entra no prêmio se acumula rodada após rodada.',
  milharFlowWinTitle: 'Quando alguém ganha o prêmio acumulado',
  milharFlowWinner: 'Vai para quem ganhou',
  milharFlowSeed: 'Próxima rodada',
  milharFlowWinHint: 'Os %seed% que ficam viram o prêmio inicial da rodada seguinte — é a faixa turquesa do gráfico no topo.',
  milharFlowWinHintNoChart: 'Os %seed% que ficam viram o prêmio inicial da rodada seguinte.',
  milharErrRiskLimit: 'Este número não está disponível nesta rodada. Escolha outro.',
  milharErrBalance: 'Saldo insuficiente para esta aposta.',
  milharErrRoundLocked: 'Esta rodada fechou. Sua aposta não entrou.',
  milharErrPrevDrawing: 'Espere o resultado da rodada anterior — só um instante.',
  milharErrInvalidPick: 'Número inválido. Confira os dígitos.',
  milharErrUnavailable: 'O jogo está indisponível agora.',
  milharErrGeneric: 'Não deu certo. Tente de novo.',
  milharMyBetsAll: 'Ver todas as minhas apostas',
  milharPoolInjected: 'desta rodada · %n% de bônus da casa',
  milharMoreOptions: 'Mais opções',
  milharOptionsSummary: '%r% rodada(s) · %b% bilhete(s)',
  milharPayoutJackpot: 'Acum.',
  milharPayoutHint: 'acerte a partir do último dígito',
  milharFeedLive: 'ao vivo',
  milharFeedNow: 'agora',
  milharFeedSecs: '%n%s',
  milharFeedMins: '%n%min',
  milharFeedSeeAll: 'Ver todos os %n% que estão nesta rodada',
  milharBuyersTitle: 'Quem está nesta rodada',
  milharBuyersCount: '%p% pessoas · %t% bilhetes · Rodada #%r%',
  milharBetIsPublic: 'Sua aposta aparece na lista desta rodada',
  milharGuestFreeToPick: 'Escolher número é livre · para apostar, entre na sua conta',
  milharPeopleCount: '%n% pessoas',
  milharYourNumber: 'seu número',
  milharLedgerTitle: 'Extrato do Acumulado',
  milharLedgerIn: 'Entrou',
  milharLedgerOut: 'Saiu',
  milharLedgerSeed: 'Semente',
  milharLedgerPot: 'Acumulado sobre a semente',
  milharLedgerPrize: 'Quem acertar leva agora',
  milharLedgerPrizeHint: 'O pote inteiro é a semente + o acumulado. Quem acerta leva 80% dele — os outros 20% viram a semente da próxima rodada.',
  milharLedgerUnavailable: 'Não foi possível carregar o Acumulado agora. Tente de novo em instantes.',
  milharLedgerEveryRound: 'Toda rodada',
  milharLedgerLoadMore: 'Ver rodadas anteriores',
  milharLedgerPaid: 'PAGOU',
  milharLedgerBalanced: 'Entrou = Saiu + Semente + Acumulado',
  milharBrlOnly: 'Milhar aceita apenas BRL',
  lobbyRoundStatus: 'Status da rodada',
  lobbySameDraw: 'Todos os jogos compartilham a mesma rodada',
  lobbyCloses: 'FECHA',
  lobbyDrawing: 'SORTEANDO',
  lobbyRoundLoading: 'Atualizando a rodada…',
  lobbyRoundUnavailable: 'Rodada indisponível',
  lobbyRoundUnavailableBody: 'Não foi possível confirmar o horário agora.',
  lobbySeeGames: 'Escolher um jogo',
  lobbyTrustTitle: 'Prometemos que cada sorteio é justo.',
  lobbyTrustBody: 'Ele acontece em público — e você pode conferir.',
  lobbyChooseGame: 'O que você quer jogar?',
  lobbyChooseGameBody: 'Escolha o jogo primeiro. Depois compare salas por limite e movimento.',
  lobbyContinue: 'Continuar',
  lobbyGameLastdigit: 'Acerte o último número, par ou ímpar.',
  lobbyGameSicbo: 'Acerte o total ou combine os dados.',
  lobbyGameRoulette: 'Escolha números, cores, par ou ímpar.',
  lobbyGameEasy: 'Mais fácil',
  lobbyGameOptions: 'Mais opções',
  lobbyGameClassic: 'Clássico',
  lobbyPublicResults: 'Resultados públicos',
  lobbyPublicResultsShort: 'Públicos',
  lobbyLatest8Public: 'Últimos 8 · públicos',
  lobbyResultsUnavailable: 'Resultados indisponíveis',
  lobbyOnlineNow: '%n% online agora',
  lobbyOnlineUnavailable: 'Online indisponível',
  lobbyOnlineUnavailableShort: '— online',
  lobbyChooseRoomAction: 'Ver salas',
  lobbyRecentResults: 'Sorteios recentes',
  lobbyChooseRoom: 'Escolha uma sala',
  lobbyRoomDifference: 'Neste jogo, todas as salas usam o mesmo resultado. Mudam limites, acesso e movimento.',
  lobbyRecommended: 'Mais ativa',
  lobbyRoomDisplayName: 'Sala %tier%',
  lobbyRoomDisplayNumbered: 'Sala %tier% %number%',
  lobbyActiveReason: '%bets% apostas · %online% pessoas agora',
  lobbyActiveReasonGuest: 'A partir de %min% · %online% pessoas agora',
  lobbyCanEnter: 'Você pode entrar',
  roomDirectorySameDraw: 'Todas as salas usam o mesmo sorteio.',
  roomDirectoryRecommended: 'Recomendada para você',
  roomDirectoryRecommendedShort: 'Recomendada',
  roomDirectoryAccessType: 'Tipo de sala',
  roomDirectoryPublic: 'Públicas',
  roomDirectoryPrivate: 'Privadas',
  roomDirectorySoon: 'Em breve',
  roomDirectoryFilterTier: 'Filtrar por nível',
  roomDirectoryAll: 'Todas',
  roomDirectoryRoomN: 'Sala %n%',
  roomDirectoryPlay: 'Jogar',
  roomDirectoryVipShort: 'VIP %vip%',
  roomDirectoryPrivateTitle: 'Salas privadas em breve',
  roomDirectoryPrivateBody: 'Códigos, convites e suas salas ficarão separados das salas públicas.',
  roomDirectoryNoRooms: 'Nenhuma sala neste filtro',
  roomDirectoryBackBadge: '%pct%% de volta',
  roomDirectoryOnline: '%n% lá dentro',
  roomDirectoryPerPlayer: 'Por jogador / rodada',
  roomDirectoryRoomCap: 'Limite da sala / rodada',
  roomDirectoryCashbackThreshold: 'Cada aposta de %min% ou mais entra no cashback',
  roomDirectoryNoVipThreshold: 'Sem nível VIP mínimo',
  roomDirectoryVipThreshold: 'Requer VIP %vip%',
  roomDirectorySignInPopup: 'Entre na sua conta para acessar esta sala.',
  roomDirectoryVipGatePopup: 'Esta sala requer VIP %vip%. Seu nível atual é VIP %my%.',
  roomDirectoryUnavailable: 'Indisponível no momento',
  roomDirectoryGuestAccess: 'Acesso para visitante',
  roomDirectorySignInRequired: 'Entre na conta para acessar',
  roomDirectoryRequiresVip: 'Requer VIP %vip%',
  roomDirectoryViewVip: 'Ver níveis VIP',
  roomDirectoryAccessGranted: 'Acesso liberado',
  roomDirectoryLiveNow: 'Ao vivo agora',
  roomDirectoryLiveSummary: '%online% pessoas em %rooms% salas',
  roomDirectoryBetsThisRound: '%n% apostas nesta rodada',
  roomDirectoryMostActive: 'Mais ativa',
  loginWelcome: 'Bem-vindo de volta',
  loginWelcomeFirst: 'Entre na sua conta',
  fairnessTitle: 'Sorteio justo · Como funciona',
  fairnessDesc: 'Veja exatamente como cada sorteio é calculado a partir de hashes Ethereum',
  passwordRuleHint: 'Senha: 6-32 caracteres, com pelo menos 1 letra e 1 número',
  placeholderPwdNew: 'Nova senha',
  placeholderIdentifier3: 'E-mail, telefone ou usuário',
  placeholderPwd: 'Senha',
  guest: 'Visitante',
  guestBanner: 'Você está no modo visitante',
  guestBannerCTA: 'Cadastre-se',
  guestCta: 'Entrar como visitante',
  guestExitLink: 'Sair do modo visitante',
  guestGateCTA: 'Cadastre-se',
  guestGateLogin: 'Já tenho conta',
  guestSheetTitle: 'Crie sua conta para continuar',
  guestSheetBody: 'Cadastre-se em 30s para apostar, conversar, depositar pelo Pix e receber prêmios.',
  guestSheetBodyNoPix: 'Cadastre-se em 30s para apostar, conversar, depositar e receber prêmios.',
  guestSheetSignup: 'Cadastre-se',
  guestSheetLogin: 'Já tenho conta',
  guestSheetCancel: 'Continuar explorando',
  guestProfileSheetTitle: 'Entre para ver perfis',
  guestProfileSheetBody: 'Visitantes veem só o nome e o avatar. Entre para ver as estatísticas deste jogador e segui-lo.',
  guestProfileGateBody: 'Cadastre-se para acompanhar seu nível, prêmios VIP e preferências.',
  guestProfileGateTitle: 'Seu perfil aparece aqui',
  guestHistoryGateBody: 'Cadastre-se para acompanhar cada aposta, depósito, saque e recompensa.',
  guestHistoryGateTitle: 'Seu histórico aparece aqui',
  guestReadOnly: 'Você está só olhando',
  guestWalletGateBody: 'Cadastre-se em 30s para depositar pelo Pix, apostar e sacar prêmios.',
  guestWalletGateBodyNoPix: 'Cadastre-se em 30s para depositar, apostar e sacar prêmios.',
  guestWalletGateTitle: 'Sua carteira aparece aqui',
  hall: 'Início',
  hot: 'EM ALTA',
  inviteCode: 'Código de convite / promoção (opcional)',
  invitePlaceholder: 'Digite o código',
  language: 'Idioma',
  langSheetTitle: 'Idioma · Language',
  liveRooms: 'Salas ao vivo',
  leaderboardAllGames: 'Todos os jogos',
  leaderboardAllRooms: 'Todas as salas',
  leaderboardRoomFilter: 'Sala',
  leaderboardBoardLabel: 'Tipo de ranking',
  leaderboardBoardProfit: 'Quem mais ganhou',
  leaderboardBoardWins: 'Maiores prêmios',
  bigWinsGameAll: 'Todos',
  bigWinsGameMilhar: 'Milhar',
  bigWinsGameMilharHora: 'Milhar da Hora',
  bigWinsJackpot: 'ACUMULADO',
  bigWinsLastJackpot: 'Último acumulado pago',
  bigWinsJackpotToday: 'hoje',
  bigWinsJackpotYesterday: 'ontem',
  bigWinsJackpotDaysAgo: 'há %n% dias',
  bigWinsSummary: '%n% prêmios no período',
  bigWinsFromStake: 'de %v%',
  bigWinsEmptyTitle: 'Nenhum grande prêmio neste período',
  bigWinsEmptyBody: 'Só entram prêmios a partir de 50 vezes a aposta. Tente um período maior.',
  bigWinsSeeLonger: 'Ver 30 dias',
  bigWinsPeriod7d: '7 dias',
  bigWinsPeriod30d: '30 dias',
  leaderboardOnlineOnly: 'Jogando agora',
  leaderboardFilters: 'Filtros',
  leaderboardFiltersDone: 'Pronto',
  leaderboardSortLabel: 'Ordenar por',
  leaderboardSortProfit: 'Lucro',
  leaderboardSortRoi: 'Retorno',
  leaderboardSortStreak: 'Vitórias seguidas',
  leaderboardMinPlays: 'Mínimo de apostas',
  leaderboardMinPlaysHint: 'Ganhar uma aposta só não é 100% de acerto — por isso pedimos um mínimo.',
  leaderboardMinPlaysNote: 'Só quem está no lucro neste período (mín. %n% apostas).',
  leaderboardNoWinnersNote: 'Ninguém está no lucro neste período — o ranking mostra quem chegou mais perto.',
  leaderboardEmptyOnlineTitle: 'Ninguém do ranking está na mesa agora',
  leaderboardEmptyOnlineBody: 'Tire o filtro para ver quem jogou neste período.',
  leaderboardShowAll: 'Ver todos',
  leaderboardPlayingNow: 'Na mesa agora',
  leaderboardPlayingIn: 'Jogando em %room%',
  leaderboardMyRankUnranked: 'Você ainda não está no ranking',
  leaderboardMyRankNeed: 'Faltam %n% apostas para entrar',
  // ---- Salão redesenhado (lobby.next) ----
  hallNextJackpots: 'Prêmios acumulados',
  hallNextLive: 'Salas ao vivo',
  hallNextLiveTag: 'AO VIVO',
  hallNextHow: 'Como funciona',
  hallNextCreed1: 'Ninguém controla o resultado.',
  hallNextCreed2: 'Não confie. Confira.',
  hallNextCheck: 'Como conferir',
  hallNextFloor: 'Agora no Sorteia',
  hallNextPlaying: '%n% jogando',
  hallNextPlayingNow: '%n% jogando agora',
  hallNextRoundAdded: '+%v% nesta rodada',
  hallNextRankingWindow: 'Últimos 60 min',
  hallNextTierSoon: 'em breve',
  hallNextTables: '%n% salas',
  hallNextTablesDraw: '%n% salas · sorteio a cada 5 min',
  hallNextRoomsOne: '%n% sala',
  hallNextPayTeaser: 'De %v% por 1 dígito até o Acumulado',
  hallNextDryDays: '%n% dias sem Acumulado',
  hallNextDryDay: '1 dia sem Acumulado',
  hallNextHits: '%n% dígitos',
  milharDetailHitOne: '1 dígito',
  hallNextHitsOne: '1 dígito',
  hallNextHitsAll: 'todos os %n%',
  hallNextLadderDrawn: 'saiu %n%',
  hallNextPick: 'Escolher meu número · %v%',
  hallNextPickShort: 'Escolher meu número',
  hallNextRaffleFree: 'GRÁTIS',
  hallNextRaffleGuest: 'Prêmios todo dia',
  hallNextRaffleEntry: 'Participe com bilhetes',
  hallNextSocialEmpty: 'Ver o ranking',
  lobbyFollowsTitle: 'Quem você segue',
  lobbyFollowsLive: '%n% jogando agora',
  lobbyFollowsIdle: '%n% seguindo · ninguém na mesa agora',
  roomFeedFollowingBadge: 'Seguindo',
  leaderboardEmptyBody: 'O ranking aparece depois que jogadores apostam nesta moeda e período.',
  leaderboardEmptyTitle: 'Ainda sem apostas ranqueadas',
  leaderboardEmptyNoProfitTitle: 'Ninguém está no lucro neste período ainda',
  leaderboardEmptyNoProfitBody: 'O ranking mostra quem está ganhando. Tente um período maior, ou vá ganhar.',
  leaderboardSeeLonger: 'Tentar um período maior',
  leaderboardGameFilter: 'Jogo',
  leaderboardLoadErrorBody: 'Verifique sua conexão e tente de novo.',
  leaderboardLoadErrorTitle: 'Não foi possível carregar o ranking',
  leaderboardLoadingTitle: 'Carregando ranking...',
  leaderboardOnlyPodium: 'A lista completa aparece quando houver mais jogadores ranqueados.',
  leaderboardPeriod: 'Período do ranking',
  leaderboardRoomsLoadError: 'Não foi possível carregar a lista de salas.',
  leaderboardRoomsLoading: 'Carregando salas...',
  leaderboardTitle: 'Ranking',
  publicProfileBets: 'Apostas',
  publicProfileHighestVip: 'VIP máximo',
  publicProfileNoBets: 'Sem apostas recentes',
  publicProfilePeriod: 'Período do perfil',
  publicProfilePrivate: 'Estatísticas privadas',
  publicProfileProfit: 'Lucro',
  publicProfileLastPick: 'Última escolha',
  publicProfileRecentBets: 'Apostas recentes',
  publicProfileSeeMore: 'Ver mais',
  publicProfileRecentBetsOf: '%n% de %total%',
  publicProfileRaffleWins: 'Prêmios',
  publicProfileRoomAdmin: 'Admin da sala',
  publicProfileTitle: 'Perfil público',
  publicProfileUnavailable: 'Estatísticas indisponíveis',
  publicProfileWinRate: 'Taxa de acerto',
  publicProfileWinRateHint: 'por aposta',
  publicProfileWins: 'Vitórias',
  publicProfileStake: 'Apostou',
  publicProfileRound: 'Rodada',
  publicProfileWon: 'Ganhou',
  publicProfileLost: 'Perdeu',
  profileFollow: 'Seguir',
  profileFollowing: 'Seguindo',
  profileFollowers: 'seguidores',
  profileFollowerOne: 'seguidor',
  publicProfileRaffleTitle: 'Sorteios',
  publicProfileRaffleEntered: 'Participações',
  publicProfileRaffleLast: 'Último prêmio',
  publicProfileRaffleNone: 'Ainda não participou de sorteios.',
  pullToRefresh: 'Puxe para atualizar',
  loading: 'Carregando',
  loadingRoom: 'Carregando sala',
  loadingRooms: 'Carregando salas…',
  loadingRoomsBody: 'Buscando salas disponíveis.',
  login: 'Entrar',
  loginAction: 'Entrar',
  loginTabPassword: 'Senha',
  loginTabOtp: 'Código único',
  loginOtpHelp: 'Vamos enviar um código de 6 dígitos para o seu dispositivo.',
  loginOtpSendCta: 'Enviar código único',
  loginOtpResend: 'Reenviar',
  rememberMe: 'Manter conectado',
  loginOtpLockedHourly: 'Muitas tentativas. Tente de novo em uns %min% min.',
  loginOtpLockedDaily: 'Limite diário atingido. Fale com o suporte.',
  loginOtpLockedIp: 'Muitas tentativas deste dispositivo.',
  placeholderIdentifier: 'E-mail ou telefone',
  placeholderPhone: 'Seu celular',
  placeholderOtpCode: 'Código',
  max: 'Máx.',
  agreeTermsLabelPrefix: 'Tenho 18+ e aceito ',
  legalTerms: 'Termos',
  legalPrivacy: 'Privacidade',
  legalResponsible: 'Jogo responsável',
  legalAge: '18+',
  cnpjLine: 'Sorteia Brasil Ltda · São Paulo, SP',
  intlEntityLine: 'Sorteia Gaming Limited',
  marketingOptIn: 'Quero receber novidades e promoções',
  maintenanceTitle: 'Em manutenção',
  maintenanceDefault: 'Manutenção em andamento. Tente novamente em instantes.',
  maintenanceGame: 'Apostas e sorteios estão pausados temporariamente.',
  maintenanceWallet: 'Depósitos e saques estão pausados por enquanto.',
  mainNavigation: 'Navegação principal',
  me: 'Perfil',
  meActivityNotifications: 'Avisos de promoções',
  meDeviceNotifications: 'Notificações neste dispositivo',
  pushEnabled: 'Notificações do dispositivo ativadas',
  pushDisabled: 'Notificações do dispositivo desativadas',
  pushEnableFailed: 'Não foi possível ativar as notificações',
  pushPermissionBlocked: 'As notificações estão bloqueadas nas configurações do navegador',
  pushUnsupported: 'Este navegador não oferece notificações push',
  pushUnavailable: 'Indisponível',
  activityNotificationConfirmEnableTitle: 'Ativar avisos de promoções?',
  activityNotificationConfirmEnableBody: 'Avisos opcionais aparecerão em Avisos e poderão ser enviados aos seus dispositivos ativos.',
  activityNotificationConfirmDisableTitle: 'Desativar avisos de promoções?',
  activityNotificationConfirmDisableBody: 'Os avisos opcionais serão desativados em toda a sua conta. Avisos obrigatórios ainda poderão aparecer.',
  deviceNotificationConfirmEnableTitle: 'Ativar notificações neste dispositivo?',
  deviceNotificationConfirmEnableBody: 'Seu navegador poderá pedir permissão. Este dispositivo será registrado para receber notificações push.',
  deviceNotificationConfirmDisableTitle: 'Desativar notificações neste dispositivo?',
  deviceNotificationConfirmDisableBody: 'Este dispositivo deixará de receber notificações do sistema. Seus outros dispositivos não serão afetados.',
  notificationConfirmCancel: 'Cancelar',
  notificationConfirmEnable: 'Ativar',
  notificationConfirmDisable: 'Desativar',
  auditProgressEntry: 'Progresso do rollover',
  auditProgressTitle: 'Progresso do rollover',
  auditSourceDeposit: 'Depósito',
  auditSourceDepositCouponBonus: 'Bônus de cupom de depósito',
  auditSourceBonus: 'Bônus promocional',
  auditSourcePrincipal: 'Valor depositado',
  auditProgressSub: 'Acompanhe cada depósito e bônus separadamente. Ver não exige verificação de identidade.',
  auditPrincipal: 'Rollover do depósito',
  auditBonus: 'Rollover do bônus',
  auditCompleted: 'Concluído',
  auditRemaining: 'Restante',
  auditBonusExhausted: 'Bônus esgotado',
  auditBonusExhaustedNote: 'Este bônus não tem mais requisito de apostas.',
  auditNoRecords: 'Você não tem requisitos pendentes ou concluídos.',
  auditLoadFailed: 'Não foi possível carregar o progresso.',
  meBetHistory: 'Histórico de apostas',
  meEyebrow: 'Conta',
  meIdLabel: 'ID Sorteia',
  meIdTapHint: 'Toque para copiar',
  meStatsPeriodNote: 'Totais desde o cadastro · Veja últimas 24h em Top',
  meFollowsEntry: 'Seguindo e seguidores',
  followsFollowersTab: 'seguidores',
  followsFollowerOne: 'seguidor',
  followsFollowingTab: 'seguindo',
  followsSearch: 'Buscar',
  followsFollowBack: 'Seguir de volta',
  followsEmptyFollowing: 'Você ainda não segue ninguém. Toque em um jogador nos sorteios ou no Top para ver o perfil.',
  followsEmptyFollowers: 'Ainda ninguém segue você.',
  followsEmptySearch: 'Ninguém com esse nome.',
  meFooter: 'v0.2.0 · Sorteio justo',
  meLeaderboardPublic: 'Ranking público',
  meLanguage: 'Idioma',
  meNetResult: 'Resultado total',
  meRulesEntry: 'Sorteio justo · regras do jogo',
  meBags: 'Bolsas e prêmios diários',
  meTransactionRecords: 'Histórico de transações',
  meInvite: 'Indicar amigos',
  meSecurity: 'Segurança e dispositivos',
  profileEditTitle: 'Editar perfil',
  profileEditSub: 'Atualize nome público e avatar',
  usernameEditTitle: 'Alterar nome de usuário',
  usernameEditSubtitle: 'Primeira troca quando quiser · depois a cada 15 dias',
  usernameTitle: 'Escolha seu nome de usuário',
  usernameSubtitle: 'Único na Sorteia · você pode trocar a cada 15 dias',
  usernameGuidance: 'Use um apelido que seus amigos reconheçam.',
  usernameAnonWarn: 'Esse nome parece genérico. Que tal um que seus amigos reconheçam?',
  usernameCurrentLabel: 'Atual:',
  usernameFieldLabel: 'Nome de usuário',
  usernameSuggestShort: 'Sortear',
  usernameRulesShort: '5–20 caracteres · letras, números, _ e .',
  usernamePlaceholder: 'ex.: onca.sortuda',
  usernameSuggestBtn: 'Gerar aleatório',
  usernameNextChangeNotice: 'Depois de salvar, a próxima troca só daqui a 15 dias.',
  usernameGraceBadge: 'Primeira troca disponível quando quiser',
  usernameErrCooldown: 'Você pode trocar novamente em %date%',
  usernameErrTooShort: 'Muito curto · mínimo 5 caracteres',
  usernameErrTooLong: 'Muito longo · máximo 20 caracteres',
  usernameErrFirstChar: 'Tem que começar com uma letra',
  usernameErrInvalidChar: 'Apenas letras, números, _ e . são permitidos',
  usernameErrConsecutive: 'Não pode ter . ou _ seguidos',
  usernameErrTrailing: 'Não pode terminar com . ou _',
  usernameErrReserved: 'Esse nome não é permitido',
  usernameErrTaken: 'Esse nome já está em uso',
  usernameErrInvalid: 'Nome inválido',
  usernameErrSame: 'Esse já é seu nome atual',
  usernameSuggestRateLimit: 'Aguarde um momento antes de gerar de novo',
  usernameAccentRemoved: 'Acentos foram removidos automaticamente',
  usernameRulesInline: '5–20 caracteres · letra inicial · letras, números, _ e . · sem _ ou . no final',
  usernameRuleLength: '5 a 20 caracteres',
  usernameRuleFirst: 'Começar com letra (a-z, A-Z)',
  usernameRuleChars: 'Apenas letras, números, _ e .',
  usernameRuleNoTrail: 'Sem _ ou . no final',
  usernameSubmit: 'Confirmar',
  usernameSaved: 'Nome de usuário salvo',
  avatarPickerTitle: 'Mudar foto',
  avatarPickerSub: 'Escolha um padrão ou envie do seu celular',
  avatarUploadCta: 'Enviar do celular',
  avatarUploadHint: 'JPG ou PNG · até 10 MB',
  avatarCurrentLabel: 'Sua foto atual',
  avatarCurrentHint: 'Toque em outra opção para trocar',
  avatarCropTitle: 'Ajuste sua foto',
  avatarCropHint: 'Arraste para mover · use o controle para aproximar',
  avatarCropZoomLabel: 'Aproximar',
  avatarCropCancel: 'Cancelar',
  avatarCropSave: 'Salvar',
  avatarSaving: 'Salvando...',
  avatarErrFormat: 'Formato não suportado · use JPG ou PNG',
  avatarErrTooBig: 'Arquivo muito grande · máximo 10 MB',
  avatarSaved: 'Avatar atualizado',
  avatarRemove: 'Remover',
  avatarRemoved: 'Foto removida',
  avatarErrLoad: 'Erro ao carregar imagem',
  avatarGroup_animais: 'Animais do Brasil',
  avatarGroup_folclore: 'Folclore',
  avatarGroup_futebol: 'Futebol',
  avatarGroup_carnaval: 'Carnaval',
  avatarGroup_praia: 'Praia e Verão',
  avatarGroup_comidas: 'Comidas',
  avatarGroup_sorte: 'Sorte',
  avatarGroup_pessoas: 'Pessoas',
  avatarGroup_monstros: 'Monstrinhos',
  avatarGroup_festa: 'Festa e Música',
  securityTitle: 'Segurança e dispositivos',
  securitySubtitle: 'Proteja sua conta e veja sessões ativas',
  securitySettingsLabel: 'Configurações de segurança',
  securityStrengthStrong: 'Forte',
  securityStrengthMedium: 'Média',
  securityStrengthWeak: 'Fraca',
  securityPasswordTitle: 'Alterar senha',
  securityPasswordBody: 'Troque sua senha de vez em quando.',
  securityPasswordReady: 'Ativa',
  securityPasswordCta: 'Alterar senha',
  securityPasswordResetSubtitle: 'Enviaremos um código para confirmar que a conta é sua.',
  securityPasswordIdentifier: 'Receber código em',
  securityPasswordIdentifierMissing: 'Adicione telefone ou e-mail verificado para alterar a senha.',
  securityPasswordNewLabel: 'Nova senha',
  securityPasswordChangedLogin: 'Senha alterada. Entre novamente.',
  securityEmailTitle: 'Verificação de e-mail',
  securityEmailBodyTodo: 'Verifique seu e-mail para nunca perder o acesso à sua conta.',
  securityEmailBodyDone: 'E-mail verificado.',
  securityEmailCtaVerify: 'Verificar e-mail',
  securityEmailCtaAdd: 'Adicionar e-mail',
  securityEmailCtaChange: 'Alterar e-mail',
  securityNoEmail: 'Sem e-mail cadastrado',
  securityPhoneTitle: 'Verificação de telefone',
  securityPhoneBodyTodo: 'Verifique seu telefone para receber alertas e recuperar a senha.',
  securityPhoneBodyDone: 'Telefone verificado.',
  securityPhoneCtaVerify: 'Verificar telefone',
  securityPhoneCtaAdd: 'Adicionar telefone',
  securityPhoneCtaChange: 'Alterar telefone',
  securityNoPhone: 'Sem telefone cadastrado',
  securitySessionsLabel: 'Sessões ativas',
  securityCurrent: 'Este dispositivo',
  securityActive: 'Ativa',
  securityEnded: 'Encerrada',
  securityCreated: 'Criada',
  securityExpires: 'Expira',
  securitySignOut: 'Sair',
  securityEmpty: 'Nenhuma sessão ativa encontrada',
  securityLoadFailed: 'Não foi possível carregar sessões',
  securityRevokeFailed: 'Não foi possível encerrar a sessão',
  verifySheetTitlePhone: 'Verificar telefone',
  verifySheetTitleEmail: 'Verificar e-mail',
  verifyIntroReward: 'Verifique para ganhar 1 bilhete de sorteio grátis.',
  verifyConfirmBtn: 'Verificar e ganhar',
  verified: 'Verificado',
  kycRequiredTitle: 'Verifique sua identidade antes',
  kycRequiredBody: 'A regulação brasileira exige uma verificação de identidade antes de qualquer saque. Leva uns 2 minutos.',
  kycRequiredBodyNoPix: 'A regulação exige uma verificação de identidade antes de qualquer saque. Leva uns 2 minutos.',
  kycRequiredCta: 'Verificar agora',
  kycLater: 'Depois',
  kycFormTitle: 'Verificação de identidade',
  kycFormCpf: 'CPF',
  kycFormBirth: 'Data de nascimento',
  kycFormPhoto: 'Selfie com o documento',
  kycFormPhotoHint: 'Foto frontal segurando o documento ao lado do rosto.',
  kycFormPhotoUpload: 'Tirar foto',
  kycFormPhotoDone: 'Foto enviada',
  kycFormSubmit: 'Enviar para análise',
  kycFormSubmitting: 'Analisando seus documentos…',
  kycFormApproved: 'Verificado · você já pode sacar',
  kycFormApprovedSub: 'Tudo certo. A verificação vale por 24 meses.',
  kycFormBackToWithdraw: 'Continuar para o saque',
  kycStatusVerifiedBody: 'Identidade verificada para saques.',
  kycStatusPending: 'Em análise',
  kycStatusRejected: 'Revisar dados',
  kycStatusNone: 'Não verificado',
  verifyRewardToast: 'Verificado! Seu prêmio está na Central de prêmios',
  verifyDoneNoReward: 'Contato verificado',
  verifyContactFailed: 'Não foi possível verificar. Confira o código e tente de novo.',
  verifySendFailed: 'Não foi possível enviar o código. Tente de novo.',
  verifyOtpInvalid: 'Código incorreto. Confira e tente de novo.',
  verifyOtpExpired: 'O código expirou. Peça um novo.',
  verifyOtpTooManyToday: 'Muitas tentativas. Tente novamente mais tarde.',
  verifyOtpSmsUnavailable: 'Envio de SMS indisponível agora. Tente mais tarde.',
  verifyOtpEmailUnavailable: 'Envio de e-mail indisponível agora. Tente mais tarde.',
  verifyPhoneTaken: 'Este telefone já está em uso por outra conta.',
  verifyEmailTaken: 'Este e-mail já está em uso por outra conta.',
  verifyCurrentPhone: 'Número atual: %v%',
  verifyChangePhoneHint: 'Enviaremos um código para o novo número.',
  verifyChangeEmailHint: 'Enviaremos um código para o novo e-mail.',
  verifyStepNumber: 'Número',
  verifyStepEmail: 'E-mail',
  verifyStepCode: 'Código',
  verifyStepDone: 'Pronto',
  verifyFieldPhone: 'Seu número de celular',
  verifyBrHint: 'Celular do Brasil: DDD + 9 + 8 dígitos.',
  verifyNumberValid: 'Número válido.',
  verifyCountryLocked: 'País do cadastro — não muda aqui.',
  verifySentTo: 'Digite o código enviado para %v%.',
  verifyResend: 'Reenviar código',
  verifyResendIn: 'Reenviar em %s%s',
  verifyChangeNumberBtn: 'Trocar número',
  verifyChangeEmailBtn: 'Trocar e-mail',
  verifyDoneChangeTitle: 'Número atualizado!',
  verifyDoneVerifyTitle: 'Contato verificado!',
  verifyDoneChangeBody: 'Agora você entra com %v%.',
  verifyDoneVerifyBody: 'Tudo certo — seu contato está verificado.',
  verifyDoneCta: 'Concluir',
  verifyIntroRewardAmount: 'Verifique para ganhar %v%.',
  verifyIntroPlain: 'Confirme seu contato para proteger a conta.',
  verifyRewardGot: 'Você ganhou %v% — resgate na Central de prêmios.',
  authOtpSent: 'Código enviado',
  otpCode: 'Código de verificação',
  sendOtp: 'Enviar código',
  loginOtpExpiresIn: 'Código expira em %t%',
  meTotalBets: 'Apostas (total)',
  meWon: 'Vitórias (total)',
  idCopied: 'ID copiado',
  idCopyFail: 'Não foi possível copiar · selecione manualmente',
  activitiesTitle: 'Promoções',
  activitiesSub: 'Confira as recompensas ativas',
  activitiesLoadError: 'Não foi possível carregar promoções',
  activitiesEmpty: 'Sem promoções ativas agora',
  activitiesDismiss: 'Ocultar promoção',
  activitiesClaimPending: 'Resgate em breve',
  actTournamentToast: 'Torneio em breve',
  actKycToast: 'Verificação em breve',
  activitiesLocked: 'Bloqueado',
  activitiesLockedToast: 'Continue jogando para desbloquear.',
  activitiesCashbackAuto: 'Cashback é creditado automaticamente.',
  activitiesActionDone: 'Ação registrada.',
  activitiesExpiresIn: 'Expira em %t%',
  activitiesCheckinsTitle: 'Prêmios diários',
  rewardsReadyCount: '%n% prêmios prontos para resgatar',
  rewardsHistoryEmpty: 'Nenhum prêmio resgatado ainda',
  rewardsHistoryEmptyHint: 'O que você resgatar aparece aqui.',
  rewardsRaffleTitle: 'Sorteio diário',
  rewardsRaffleFree: 'Grátis',
  rewardsRaffleUpTo: 'até %v%',
  rewardsRaffleHasTickets: 'Você tem %n% bilhetes · entre no próximo',
  rewardsRaffleNoTickets: 'Ganhe bilhetes nas missões e entre de graça',
  rewardsRaffleCta: 'Participar',
  checkinCollapsedExpand: 'Ver os 7 dias',
  rewardsCouponsCount: '%n% cupom(ns) para usar',
  activitiesCheckinClaimed: 'Check-in resgatado!',
  activitiesStreakDay: 'Sequência dia',
  activitiesCheckinDayOf: 'Dia %n% de %total%',
  activitiesCheckinToday: 'Hoje você ganha',
  activitiesCheckinAskClaimDay: 'Resgate o prêmio do dia %n%',
  activitiesCheckinAskDay7: 'Dia 7: o maior prêmio',
  activitiesCheckinAskComeBackReset: 'Volte amanhã ou a sequência recomeça',
  activitiesCheckinAskWeekDone: 'Semana completa! Volte amanhã',
  activitiesCheckinDepositAskDo: 'Deposite qualquer valor hoje',
  activitiesCheckinDepositAskDoStreak: 'Deposite hoje ou a sequência recomeça',
  actOnDeposit: 'ao depositar',
  activitiesCheckinDepositAskClaim: 'Depósito feito! Resgate agora',
  activitiesCheckinDepositAskTomorrowReset: 'Deposite amanhã ou a sequência recomeça',
  activitiesCheckinDepositAskWeekDone: 'Semana completa! Deposite amanhã',
  activitiesCheckinDepositCta: 'Depositar',
  activitiesCheckinTodayTile: 'Hoje',
  actTomorrowPrefix: 'Amanhã:',
  rewardsRaffleAskEarn: 'Ganhe bilhetes nas missões',
  rewardsRaffleAskUse: 'Use seus %n% bilhetes',
  rewardsRaffleAskUseOne: 'Use seu bilhete',
  rewardsRaffleAskEntered: 'Você está dentro com %n% bilhetes',
  rewardsRaffleAskEnteredOne: 'Você está dentro com 1 bilhete',
  rewardsRaffleAskFull: 'Sorteio lotado',
  rewardsRaffleAskLockedIn: 'Você está dentro! Boa sorte',
  rewardsRaffleAskLockedOut: 'Inscrições fechadas por hoje',
  rewardsRaffleTimeSuffix: ' · sorteio às %h%',
  rewardsRaffleTimeSuffixShort: ' · às %h%',
  rewardsRaffleCountdownSuffix: ' · sorteio em %t%',
  rewardsRaffleCountdownSuffixShort: ' · em %t%',
  rewardsRaffleWinnersNote: '· %n% ganham',
  actStepPrize: '%n%º · ×%c%',
  actStepPrizeRange: '%a%º–%b%º · ×%c%',
  actDailyMissionPoolNote: '· %v% no dia',
  actBindEmailAddCta: 'Cadastrar',
  rewardsRaffleCtaEarn: 'Ganhar bilhetes',
  rewardsRaffleCtaAdd: 'Adicionar',
  rewardsRaffleCtaNumbers: 'Ver números',
  rewardsRaffleCtaSchedule: 'Ver sorteios',
  actDailyMissionAskStart: 'Faça %rounds% rodadas de %min% ou mais',
  actDailyMissionAskLeft: 'Faltam %n% rodadas de %min% ou mais',
  actDailyMissionAskLeftOne: 'Falta 1 rodada de %min% ou mais',
  actDailyMissionAskStartNoMin: 'Faça %rounds% rodadas hoje',
  actDailyMissionAskLeftNoMin: 'Faltam %n% rodadas hoje',
  actDailyMissionAskDone: 'Missão completa · volte amanhã',
  actDailyMissionCtaDone: 'Jogar',
  actInviteAsk: 'Envie o link e ganhe no 1º depósito dele',
  actInviteAskTodayOne: '1 amigo entrou! Falta o depósito',
  actInviteAskTodayMany: '%n% amigos entraram! Falta o depósito',
  actInviteAskNext: '%n% depositaram · +%k% e sobe para %v%',
  actInviteAskEarned: '%n% depositaram · %v% ganhos',
  actInviteAskConverted: '%n% amigos já depositaram',
  actInvitePerFriend: 'por amigo',
  actStepFriendNth: '%n%º amigo',
  actStepFriendUp: '%n%º+',
  actVipUpTitleNew: 'Vire VIP %to%',
  actVipUpAskNext: 'Aposte mais %v% no total para subir',
  actVipUpAskDeposit: 'Deposite mais %v% no total para subir',
  actVipMeterBets: 'Apostas',
  actVipMeterDeposits: 'Depósitos',
  actVipRewardAtLevel: 'VIP %n%:',
  actVipUpAskNew: 'Aposte %v% no total e vire VIP %to%',
  actVipUpAskZero: 'Suba de nível apostando',
  actBindEmailAddTitle: 'Cadastre seu e-mail',
  actBindEmailAddHow: 'Cadastre um e-mail para proteger a conta',
  activitiesCheckinAskClaim: 'Resgate o prêmio de hoje',
  activitiesCheckinAskDone: 'Volte amanhã',
  activitiesCheckinAskWeek: '7 dias seguidos dão %v%',
  activitiesCheckinTomorrowLabel: 'Amanhã você ganha',
  activitiesCheckinTomorrow: 'Amanhã',
  activitiesCheckinFinale: 'Dia %d%: %v%',
  activitiesCheckinTotal: '%d% dias seguidos: %v%',
  activitiesTicketOne: '%n% bilhete',
  activitiesTicketsN: '%n% bilhetes',
  activitiesCouponOne: '%n% cupom',
  activitiesCouponsN: '%n% cupons',
  activitiesCouponWorth: 'cupom de %v%',
  activitiesClaimNow: 'Resgatar',
  activitiesClaimed: 'Resgatado',
  activitiesNotEligible: 'Bloqueado',
  activitiesCheckinClaimedAmount: 'Check-in +%v% resgatado!',
  activitiesCheckinNotEligibleBet: 'Aposte hoje para resgatar',
  activitiesCheckinNotEligibleDeposit: 'Deposite hoje',
  activitiesCheckinNotEligibleLogin: 'Volte amanhã',
  activitiesCheckinResetHint: 'Falte um dia e a sequência reinicia',
  activitiesCheckinDay: 'Dia %n%',
  rewards: 'Prêmios',
  rewardsCenter: 'Central de prêmios',
  rewardsTab: 'Prêmios',
  lobbyRankingTitle: 'Ranking',
  lobbyRankingLive: 'Ao vivo',
  lobbyRankingLeader: '%name% lidera com',
  lobbyRankingHint: 'Veja quem está ganhando mais hoje',
  rewardsCatalogTitle: 'Mais formas de ganhar',
  rewardsMissionsTitle: 'Formas de ganhar',
  rewardsComingSoon: 'Em breve',
  rewardsGo: 'Participar ›',
  rewardsLive: 'Ativo',
  rewardsAssetPendingBonus: 'Bônus a liberar',
  rewardsCatDaily: 'Diárias',
  rewardsCatDeposit: 'Depósito',
  rewardsCatVip: 'VIP',
  rewardsCatInvite: 'Convite',
  rewardsCatDraw: 'Sorteios',
  rewardsCatCashback: 'Cashback',
  rewardsCatNewcomer: 'Novato',
  catActCheckin: 'Check-in de 7 dias',
  catActDailyTask: 'Missão diária',
  catActDeposit: 'Cupom de 1º depósito',
  catActReload: 'Cupom de recarga diária',
  catActBigDeposit: 'Cupom de alto depósito',
  catActVip: 'Bônus de nível VIP',
  catActVipPeriodic: 'Prêmio VIP semanal/mensal',
  catActInvite: 'Convide amigos',
  catActRaffle: 'Sorteio diário',
  catActWheel: 'Roleta da sorte',
  catActRedpacket: 'Envelope diário',
  catActBox: 'Baú misterioso',
  catActCashback: 'Compensação do 1º dia',
  catActRescue: 'Cashback semanal',
  catActNewbie: 'Pacote de boas-vindas',
  catActBind: 'Bônus por verificar contato',
  depositCouponPickTitle: 'Cupom de depósito',
  depositCouponBest: 'Melhor',
  depositCouponRollover: 'Rollover %x%x',
  depositCouponNone: 'Sem cupom disponível para este valor',
  couponClaimed: 'Cupom resgatado!',
  couponStatusExpired: 'Expirado',
  couponEmpty: 'Nenhum cupom ainda',
  couponMinDeposit: 'Depósito mín. %v%',
  dailyPopupTitle: 'Recompensas de hoje',
  welcomePopupTitle: 'Presente de boas-vindas',
  welcomePopupSub: 'no seu 1º depósito',
  welcomePopupNote: 'Bônus nos seus %n% primeiros depósitos',
  welcomePopupNoExpiry: ' · sem prazo',
  welcomePopupDeposit: 'Depositar e ganhar %v%',
  dailyPopupLater: 'Agora não',
  dailyPopupDayOf: 'Dia %n% de 7',
  dailyPopupMulti: '%k% check-ins hoje',
  dailyPopupReady: 'Pronto para resgatar hoje',
  dailyPopupResetWarn: 'Se faltar hoje, a sequência volta para %v%',
  dailyPopupInboxExtra: '+%v% esperando em Prêmios',
  dailyPopupClaim: 'Resgatar %v%',
  depositCouponTerms: 'Até %cap% · rollover: depósito %principal%× + bônus %bonus%×',
  depositCouponTermsBonusOnly: 'Até %cap% · rollover: bônus %bonus%×',
  depositQrBonus: 'Você recebe %total% (inclui +%bonus% de bônus)',
  rewardInboxTitle: 'Suas recompensas',
  rewardClaim: 'Resgatar',
  rewardClaimedCash: '+%v% resgatado!',
  rewardClaimedTickets: '+%n% bilhetes resgatados!',
  rewardClaimedGeneric: 'Recompensa resgatada!',
  rewardTickets: '+%n% bilhetes',
  rewardTicketOne: '+1 bilhete',
  rewardClaimedTicketOne: '+1 bilhete resgatado!',
  rewardCoupon: 'Cupom',
  rewardInboxReady: '%n% para resgatar',
  rewardRecentTitle: 'Caiu na sua conta',
  rewardCreditedAuto: 'creditado automaticamente',
  rewardInboxError: 'Não foi possível carregar suas recompensas',
  rewardRollover: 'Rollover %x%x',
  rewardUnitInvites: 'convites',
  rewardUnitRounds: 'rodadas',
  rewardUnitDays: 'dias',
  rewardUnitContacts: 'contatos',
  couponCardCap: 'até %cap%',
  couponCardUnlockShort: 'Libera no %n%º',
  couponLadderNote: 'Use na ordem: cada depósito libera o próximo',
  couponRewardName: 'Cupom de depósito',
  couponPouchByExpiry: 'Use primeiro o que vence antes',
  couponRowUse: 'Usar',
  couponRowMin: 'mín %min%',
  couponMoreLink: 'Ganhe mais cupons nas promoções',
  couponEmptyCta: 'Ver promoções',
  couponCardAudit: 'Rollover: depósito %principal%× + bônus %bonus%×',
  couponCardAuditBonus: 'Rollover: bônus %bonus%×',
  couponCardUnlock: 'Libera no %n%º depósito',
  couponCardLocked: 'Bloqueado',
  couponHeroMin: 'Deposite %min% ou mais para usar',
  couponHeroHint: 'É só depositar para ganhar o bônus.',
  couponHeroUse: 'Usar no depósito',
  rewardsLockedTitle: 'Desbloqueie jogando',
  rewardsTabEarn: 'Ganhar',
  rewardsTabCoupons: 'Cupons',
  rewardsTabHistory: 'Histórico',
  couponHistoryLink: 'Histórico de cupons',
  couponHistoryUsed: 'Usados',
  couponHistoryExpired: 'Expirados',
  couponHistoryEmpty: 'Nenhum cupom usado ainda',
  couponHistoryDeposit: 'depósito %v%',
  ticketLedgerTitle: 'Meus bilhetes',
  ticketLedgerBalance: '%n% bilhetes disponíveis',
  ticketLedgerEarned: 'Ganhos',
  ticketLedgerUsed: 'Usados em sorteios',
  ticketLedgerWins: 'Prêmios',
  ticketLedgerEmpty: 'Nada por aqui ainda',
  ticketLedgerGoRaffle: 'Ir para o sorteio',
  ticketLedgerRaffle: 'Sorteio',
  rewardRules: 'Ver regras ›',
  rewardAutoTag: 'AUTOMÁTICO',
  rewardAutoTitle: 'Cai direto na carteira',
  rewardVerify: 'Verificar',
  rewardMissionsTitle: 'Missões',
  rewardPreviewTag: 'PRÉVIA',
  rewardHistClaimedTag: 'RESGATADO',
  rewardHistAutoTag: 'AUTO',
  rewardPreviewAutoRow: 'Convite: amigo depositou',
  activitiesClaimFailed: 'Não foi possível resgatar agora',
  activitiesAuditTitle: 'Rollover pendente',
  activitiesAuditActive: 'Ativos',
  activitiesAuditRemaining: 'Falta apostar',
  activitiesAuditEmpty: 'Nenhum requisito ativo.',
  activitiesClaimsTitle: 'Recompensas recentes',
  activitiesTrackLogin: 'Entre todo dia',
  activitiesTrackBet: 'Aposte todo dia',
  activitiesTrackDeposit: 'Deposite todo dia',
  activitiesTypeCheckin: 'Check-in',
  activitiesTypeWelcomePack: 'Pacote de boas-vindas',
  activitiesTypeInvite: 'Indicação de amigo',
  activitiesTypeWeeklyRescue: 'Cashback semanal',
  activitiesTypeDailyBet: 'Apostas diárias',
  activitiesTypeBindContact: 'Contato verificado',
  activitiesTypeVip: 'VIP',
  activitiesTypeDepositBonus: 'Bônus de depósito',
  activitiesTypeLossComp: 'Cashback de perdas',
  activityFallback: 'Promoção',
  actDailyMissionTitle: 'Missão de hoje',
  actDailyMissionSecondary: 'Aposte %rounds% rodadas de %min% ou mais',
  actDailyMissionCta: 'Jogar agora',
  actBindTitle: 'Verifique seu contato',
  actBindSecondary: 'E-mail e telefone · %days% dias para resgatar',
  actBindCta: 'Verificar',
  actBindEmailTitle: 'Verifique seu e-mail',
  actBindPhoneTitle: 'Verifique seu telefone',
  actBindClaimDays: '%days% dias para resgatar',
  actBindEmailHow: 'Proteja a conta e recupere a senha',
  actBindPhoneHow: 'Proteja a conta e recupere a senha',
  actBindPerkRecover: 'Recuperar a senha',
  actBindPerkProtect: 'Conta protegida',
  actBindRewardNote: 'ao confirmar',
  actDepositBonusSecondary: 'Do 1º ao %count%º depósito · %min%% a %max%%',
  actDepositBonusDone: 'Todos os %count% depósitos concluídos',
  actInviteTitle: 'Convide um amigo',
  actInviteSecondary: 'Quando ele fizer o 1º depósito',
  actInviteSecondaryToday: '%n% convidados hoje · ganhe no 1º depósito deles',
  actInviteSecondaryTodayOne: '1 convidado hoje · ganhe no 1º depósito dele',
  actInviteCta: 'Convidar',
  actVipUpTitle: 'VIP %from% → VIP %to%',
  actVipUpSecondaryNext: 'Faltam %v% para o VIP %to%',
  actVipUpSecondary: 'Cada nível libera prêmios maiores',
  actVipUpCta: 'Jogar',
  actStepRounds: '%n% rodadas',
  actStepRoundsNow: '%d%/%n% rodadas',
  actStepNth: '%n%º dep.',
  actStepPlayers: '%a%-%b% jogadores',
  actStepFriends: '%a%-%b% amigos',
  actTournamentTitleMain: 'Torneio noturno',
  actTournamentStartsIn: 'Começa em %minutes% min',
  actTournamentCta: 'Ver',
  actKycTitle: 'Verifique sua identidade para sacar',
  actKycCta: 'Verificar',
  actRaffleTitleMain: 'Sorteio das %time%',
  actRaffleSecondaryEntries: '%n% inscritos',
  actRaffleLockedTitle: 'Sorteio das %time% fechado',
  actRaffleSettlingTitle: 'Sorteio das %time% em apuração',
  actRaffleSettledTitle: 'Resultado %time% · D = %d%',
  actRaffleSeeCta: 'Ver',
  actRaffleResultCta: 'Resultado',
  roomDrumDailyTitle: 'Sorteio de hoje',
  roomDrumGuestTitle: 'Sorteio público',
  roomDrumGuestSecondary: 'Entre para ver seus bilhetes e participar',
  roomDrumLogin: 'Entrar',
  roomDrumTrustTitle: 'Sorteio à vista de todos',
  roomDrumTrustSecondary: 'O resultado pode ser conferido por qualquer pessoa',
  roomDrumTrustCta: 'Como funciona',
  roomDrumClosesIn: 'Fecha em %time%',
  roomDrumDrawAt: 'Sorteio às %time%',
  roomDrumNeedsEntries: '%n%/%min% para confirmar',
  roomDrumConfirmed: 'Sorteio confirmado · %n%/%max%',
  roomDrumTicketsAvailable: 'Você tem %n% bilhete(s) · %progress%',
  roomDrumMyEntries: '%n% número(s) inscrito(s) · %progress%',
  roomDrumRegistrationClosed: 'Inscrições encerradas',
  roomDrumSettling: 'Sorteando agora…',
  roomDrumWon: 'Você ganhou R$ %value%',
  roomDrumLost: 'Dessa vez não foi',
  roomDrumVoided: 'Não chegou ao mínimo de %min%',
  roomDrumRefunded: '%n% bilhete(s) devolvido(s)',
  roomDrumMyNumbers: 'Meus números',
  roomDrumEarnTickets: 'Ganhar bilhetes',
  roomDrumViewResult: 'Ver resultado',
  roomDrumViewDraw: 'Acompanhar',
  roomDrumSeeDetails: 'Ver detalhes',
  roomDrumServiceUnavailable: 'Sorteio indisponível agora',
  roomDrumRetry: 'Tentar de novo',
  inviteTitle: 'Indicar amigos',
  inviteSubtitle: 'Compartilhe seu link. Novos cadastros ficam ligados a você automaticamente.',
  inviteCodeLabel: 'Seu código de convite',
  inviteLinkLabel: 'Link de convite',
  inviteCopyBtn: 'Copiar link',
  inviteCopied: 'Link de convite copiado',
  inviteCopyFail: 'Não foi possível copiar o convite',
  inviteCopyManual: 'Cópia bloqueada aqui — o link está acima',
  inviteStep1: 'Seu amigo se cadastra por este link.',
  inviteStep2: 'A conta aparece no seu resumo de indicações.',
  nextVip: 'Próximo VIP',
  vipDetailsTitle: 'VIP',
  vipDetailsSubtitle: 'Nível, progresso e benefícios',
  vipNextLevel: 'Próximo nível',
  vipEffectiveBet: 'Total apostado válido',
  vipToNext: 'Falta para subir',
  vipMaxLevel: 'Nível máximo',
  vipThresholdsTitle: 'Marcos de nível',
  vipBenefitsTitle: 'Benefícios VIP',
  vipBenefitMinLevel: 'Libera em',
  vipBenefitTickets: 'bilhetes',
  noRooms: 'Nenhuma sala disponível',
  noRoomsBody: 'Todas as salas estão offline no momento. Volte em breve.',
  noStagedBets: 'Adicione uma aposta',
  basketTitle: 'Suas apostas · Rodada #%round%',
  basketEmpty: 'Nenhuma aposta nesta rodada ainda',
  basketStake: 'Total apostado',
  basketMaxWin: 'Retorno máximo',
  basketBetsCount: '%n% apostas',
  basketLocked: 'Aposta confirmada',
  placeAnother: 'Fazer outra aposta',
  myRoundStatus: 'Minha rodada',
  tapToView: 'Toque para ver',
  myBets: 'Minhas apostas',
  myCurrentBets: 'Minhas apostas nesta rodada',
  online: 'online',
  on: 'Ligado',
  off: 'Desligado',
  password: 'Senha',
  passwordLoginPlaceholder: 'Sua senha',
  passwordRegisterPlaceholder: '6+ caracteres com letras e números',
  phoneEmail: 'Telefone ou e-mail',
  phoneEmailUser: 'Telefone, e-mail ou usuário',
  back: 'Voltar',
  pixDepositChooseAmt: 'Escolha um valor',
  pixDepositContinue: 'Continuar',
  depositReviewBeforeContinue: 'Confira antes de continuar',
  depositAmountQuestion: 'Quanto você quer adicionar?',
  depositAmountAria: 'Valor do depósito em reais',
  depositAmountRange: 'Mín. %min% · Máx. %max%',
  depositAmountIntegerOnly: 'Só valores sem centavos',
  depositAmountIntegerError: 'Digite um valor inteiro.',
  depositAmountMinError: 'O valor mínimo é %v%.',
  depositAmountMaxError: 'O valor máximo é %v%.',
  cashierDepositBonus: 'Bônus de depósito',
  cashierDepositBonusHint: 'Escolha este bônus ou um cupom. Requisitos de apostas se aplicam.',
  depositQuickAmounts: 'Valores rápidos',
  depositBenefitsTitle: 'Benefícios deste depósito',
  depositCouponAfterAmount: 'Cupons após escolher um valor',
  depositCouponAfterAmountSub: 'Você pode continuar sem cupom.',
  depositCouponsLoading: 'Consultando seus cupons…',
  depositCouponsUnavailableTitle: 'Cupons indisponíveis agora',
  depositCouponsUnavailableBody: 'Não conseguimos carregar seus cupons, mas dá pra depositar normalmente.',
  depositCouponsRetry: 'Tentar de novo',
  depositCouponNoneApplied: 'Nenhum cupom aplicado',
  depositCouponChoose: 'Trocar cupom (%n%)',
  depositCouponPickerClose: 'Fechar',
  depositCouponApplied: 'Aplicado',
  depositCouponEstimatedBonus: 'Bônus estimado',
  depositCouponChange: 'Trocar',
  depositCouponRemove: 'Remover',
  depositCouponPickerTitle: 'Escolher cupom',
  depositCouponPickerSub: 'Escolha no máximo um cupom para este depósito.',
  depositCouponHighestNow: 'Maior bônus agora',
  depositCouponNoCoupon: 'Nenhum cupom',
  depositCouponNoCouponSub: 'Continuar só com o valor pago',
  depositCouponApply: 'Aplicar seleção',
  depositSummaryTitle: 'Resumo',
  depositYouPay: 'Você paga',
  depositCouponBonus: 'Bônus do cupom',
  depositExpectedBalance: 'Saldo previsto',
  depositAmountRequired: 'Digite ou escolha um valor',
  depositContinueWith: 'Continuar com %v%',
  depositContinueWithoutCoupon: 'Continuar sem cupom com %v%',
  pixDepositFailedSub: 'Tente de novo — geramos um código novo na hora.',
  pixDepositUnavailableTitle: 'Página de pagamento indisponível',
  pixDepositUnavailableSub: 'Não foi possível gerar a página de pagamento agora. Tente novamente em instantes.',
  pixDepositQrSub: 'Abra a página de pagamento segura para concluir o depósito',
  pixDepositQrTitle: 'Aguardando pagamento',
  pixDepositOpenCheckout: 'Abrir página de pagamento',
  sandboxCheckoutTitle: 'Simulação de pagamento em sandbox',
  sandboxCheckoutBody: 'O provedor sandbox não retornou uma página de pagamento. Use esta tela somente para testar o retorno ao jogo.',
  sandboxCheckoutNoTransfer: 'Nenhuma transferência real será realizada.',
  sandboxCheckoutReturn: 'Concluir teste e voltar ao jogo',
  pixDepositQrTxid: 'ID da transação',
  pixDepositTipMinMax: 'Depósito mínimo R$ 20 · máximo R$ 10.000.',
  pixDepositTipTiming: 'Após o pagamento, o crédito cai na sua conta em até 1 minuto.',
  pixDepositTipSupport: 'Se algo der errado, fale com nosso atendimento — estamos aqui para ajudar.',
  pixDepositTitle: 'Depositar via Pix',
  pixDone: 'Pronto',
  pixWithdrawAmount: 'Valor do saque',
  pixWithdrawAmountHint: 'Mín %min% · Máx %max%',
  pixWithdrawAmountPlaceholder: 'Digite o valor',
  pixWithdrawAvail: 'Disponível',
  pixWithdrawChave: 'Chave Pix',
  pixWithdrawChaveNoPix: 'Conta de destino',
  pixWithdrawClose: 'Fechar',
  pixWithdrawBonusHeld: "Bônus a bloquear",
  pixWithdrawBalanceAfter: "Saldo após o pagamento concluído",
  pixWithdrawBonusLifecycle: "O bônus fica bloqueado durante o saque e só é descontado após o pagamento concluído. Se o saque for recusado ou falhar definitivamente, o bônus e sua exigência de apostas voltam a ficar disponíveis. As tentativas de pagamento mantêm o bloqueio.",
  pixWithdrawBonusPending: "Parte dos fundos está indisponível porque o bônus vinculado tem apostas não liquidadas, apostas futuras pré-pagas ou um saque em andamento. Use outros fundos disponíveis ou aguarde a conclusão.",
  pixWithdrawQuoteChanged: "Seu saldo ou bônus vinculado mudou. Confira o valor atualizado e confirme novamente.",
  walletBonusFrozen: "Bônus bloqueado para saque: %v%",
  auditWithdrawalFrozen: "Bloqueado para saque",
  auditWithdrawalForfeited: 'Descontado no saque',
  auditWithdrawalForfeitedNote: "O saque foi pago. O bônus vinculado foi descontado e sua exigência de apostas foi encerrada.",
  pixWithdrawAbandonBonus: "Concordo em abrir mão de todo o bônus restante e dos ganhos de bônus das fontes usadas neste saque (%v%), mesmo em um saque parcial.",
  pixWithdrawConfirmBtn: 'Confirmar saque',
  pixWithdrawConfirmSub: 'Depois de enviar, o Pix não pode ser cancelado.',
  pixWithdrawConfirmSubNoPix: 'Depois de enviar, a transferência não pode ser cancelada.',
  pixWithdrawConfirmTitle: 'Confirmar saque',
  pixWithdrawFailedSub: "O saque não foi concluído. Confira o status do pedido antes de tentar novamente.",
  pixWithdrawSubmittedConfirm: 'OK',
  pixWithdrawSubmittedTitle: 'Solicitação de saque enviada com sucesso',
  pixWithdrawSubmittedSub: 'A plataforma está processando o pagamento.',
  pixWithdrawSubmittedEta: 'Previsão de recebimento em até uma hora.',
  pixWithdrawUnconfirmedTitle: 'Envio do saque a confirmar',
  pixWithdrawUnconfirmedSub: 'Não foi possível confirmar o resultado do envio. Confira a lista de saques antes de tentar novamente.',
  pixWithdrawFailedTitle: 'Saque não realizado',
  pixWithdrawFee: 'Taxa',
  pixWithdrawNet: 'Você recebe',
  pixWithdrawReceived: 'Saque concluído',
  pixWithdrawReceivedSub: 'O dinheiro chega na sua conta pelo Pix em segundos.',
  pixWithdrawReceivedSubNoPix: 'O dinheiro já está a caminho da sua conta bancária.',
  pixWithdrawSent: 'Enviado ao banco',
  pixWithdrawSentSub: 'Já enviamos para o seu banco. Deve cair em instantes.',
  pixWithdrawTitle: 'Sacar via Pix',
  pixWithdrawTitleNoPix: 'Sacar',
  payeeCtaBody: 'Antes do primeiro saque, cadastre sua chave Pix. Você só precisa fazer isso uma vez — todos os próximos saques usam esses dados.',
  payeeCtaBodyNoPix: 'Antes do primeiro saque, cadastre uma conta bancária no seu nome. Você só precisa fazer isso uma vez — todos os próximos saques usam esses dados.',
  payeeCtaButton: 'Cadastrar chave Pix',
  payeeCtaButtonNoPix: 'Cadastrar conta bancária',
  payeeCtaTitle: 'Cadastre sua chave Pix',
  payeeCtaTitleNoPix: 'Cadastre sua conta bancária',
  payeeEditAction: 'Alterar',
  payeeFieldCnpj: 'CNPJ',
  payeeFieldCpf: 'CPF',
  payeeFieldPixKey: 'Chave Pix',
  payeeFieldNome: 'Nome completo',
  payeeFormEditTitle: 'Editar chave Pix',
  payeeFormEditTitleNoPix: 'Editar conta bancária',
  payeeFormSave: 'Salvar e continuar',
  payeeFormTitle: 'Cadastrar chave Pix',
  payeeFormTitleNoPix: 'Cadastrar conta bancária',
  payeeNomeHint: 'Igual ao seu documento.',
  payeePlaceholderNome: 'João da Silva',
  payeeSavedLabel: 'Chave Pix',
  payeeSavedLabelNoPix: 'Conta bancária',
  payeeTypeCnpj: 'CNPJ',
  payeeTypeCpf: 'CPF',
  payeeTypeEmail: 'E-mail',
  payeeTypeEvp: 'Chave aleatória',
  payeeTypePhone: 'Telefone',
  pickHeading: 'Em que apostar',
  tapChips: 'Escolha uma ficha',
  roundShort: 'Rodada #%n%',
  betYouBet: 'Você apostou',
  betOn: 'em',
  betIfYouWin: 'Retorno se ganhar',
  betEdgeWinNote: '%v% se sair %d%',
  betMinWinNote: 'no mínimo %v%',
  betTierBoundaryNote: 'se sair %digit%: %amount%',
  viewBasket: 'Apostas da rodada · %n%',
  btnDone: 'Pronto',
  sicboPicksLabel: 'apostas',
  sicboPickLabelOne: 'aposta',
  chipCapTooltip: 'Acima do limite da sala',
  walletMaxBetShort: 'Máx',
  maxBet: 'Aposta máxima',
  betPlacedTitle: 'Aposta feita!',
  betLockedTip: 'Confirmada · aguardando o sorteio',
  closes: 'FECHA',
  drawing: 'SORTEANDO',
  drawServiceStalled: 'Sorteio atrasado · aguarde',
  voidTitle: 'Rodada anulada',
  voidReasonChain: 'A rede pública não confirmou o resultado a tempo.',
  voidReasonSafety: 'Uma verificação de segurança impediu o sorteio.',
  voidReasonGeneric: 'Uma instabilidade técnica impediu o sorteio.',
  voidRefunded: 'Sua aposta foi devolvida',
  voidOk: 'Entendi',
  readTable: 'Ler a mesa',
  tableTrend: 'Resultados',
  tableDist: 'Distribuição',
  tablePeople: 'Jogadores',
  tablePeopleEmpty: 'Ninguém em destaque nesta rodada ainda.',
  tablePeopleEmptyHot: 'Quem está numa sequência de vitórias',
  tablePeopleEmptyWhale: 'Apostas muito acima da média da sala',
  tablePeopleEmptyCold: 'Quem está numa sequência de derrotas',
  tablePeopleEmptyNote: 'Aparecem aqui em tempo real conforme as apostas entram.',
  peopleHot: 'Pé quente',
  peopleWhale: 'Grandes apostas',
  peopleCold: 'Pé frio',
  coldStreak: '%n% derrotas',
  betCta: 'Apostar',
  chipCapToast: 'Aposta máxima nesta sala: %cap%',
  betChipAdjusted: 'Sua ficha anterior não está disponível. Selecionamos %chip%.',
  ldTierExplain: 'Se sair 0 ou 9, paga ×1,5 em vez de ×2.',
  sicboBsTripleNote: 'Trinca perde',
  sicboBsTripleExample: 'Saiu trinca? Alto e Baixo perdem, mesmo com a soma na faixa (ex: 3-3-3 = 9, Baixo perde).',
  roulHintSide: 'Toque em um lado — aposta na hora',
  sicboStagePrompt: 'Toque em um número para apostar',
  rouPendingNone: 'Toque em um número para começar',
  repeatLast: 'Repetir última',
  payeeTaxIdShortHint: 'Faltam %left% dígito(s)',
  pixDepositQrExp: 'Expira em %t%',
  pixDepositSuccess: 'Pagamento recebido',
  pixDepositSuccessSub: 'Seu saldo já foi atualizado. Bora apostar?',
  pixDepositSuccessBreakdown: '%amount% de depósito + %bonus% de bônus',
  pixDepositCancel: 'Cancelar',
  pixDepositTryAgain: 'Gerar novo código',
  pixDepositFailedTitle: 'Pagamento não concluído',
  analyticsColdAggregate: 'Qualquer par / qualquer trinca',
  analyticsColdSingles: 'Faces (em qualquer dos 3 dados)',
  analyticsColdDoubles: 'Duplas específicas',
  analyticsColdTriples: 'Trincas específicas',
  analyticsColdSums: 'Somas específicas (com pagamento)',
  sicboAnyDouble: 'Qualquer dupla',
  sicboDoubleN: 'Dupla de %n%',
  sicboTripleN: 'Trinca de %n%',
  sicboAny2Same: '2 iguais',
  sicboAny3Same: '3 iguais',
  sicboAnyTriple: 'Qualquer trinca',
  last: 'Último',
  pendingBetBadge: 'Sua aposta · #%n% sorteando',
  payeeFieldType: 'Tipo de chave Pix',
  payeeFieldTypeNoPix: 'Tipo de conta',
  ifHit: 'se acertar',
  analyticsSortBy: 'Ordenar:',
  archiveTapHint: 'Toque em qualquer rodada para conferir na blockchain',
  sicboLongPressHint: 'Segure um número para editar ou tirar fichas',
  sicboStageHint: 'Toque para apostar · toque de novo para empilhar',
  sicboSingleHelp: 'Escolha um número de 1 a 6. Você ganha se ele sair em pelo menos um dos 3 dados.',
  sicboSumLabel: 'Soma',
  triple: 'Trinca',
  youBet: 'Você aposta',
  rouConfirmCTA: 'Confirmar %n% aposta · %amount% %currency%',
  rouConfirmCTAPlural: 'Confirmar %n% apostas · %amount% %currency%',
  'tab_odd-even': 'Ímpar / Par',
  'tab_big-small': 'Alto / Baixo',
  'tab_specific': 'Número exato',
  'tab_sicbo-bs': 'Alto / Baixo',
  'tab_sicbo-sum': 'Soma',
  'tab_sicbo-single': 'Um dado',
  'tab_sicbo-combo': 'Combo',
  'tab_sicbo-pairs': 'Duplas',
  'tab_roulette-rb': 'Vermelho / Preto',
  'tab_roulette-oe': 'Ímpar / Par',
  'tab_roulette-hilo': 'Alto / Baixo',
  'tab_roulette-num': 'Números',
  'tab_roulette-dozen': 'Dúzia',
  'tab_roulette-column': 'Coluna',
  roulDozen_dz1: '1ª dúzia',
  roulDozen_dz2: '2ª dúzia',
  roulDozen_dz3: '3ª dúzia',
  'tab_roulette-split': 'Cavalo',
  'tab_roulette-street': 'Linha',
  'tab_roulette-corner': 'Quina',
  'tab_roulette-line': 'Sextina',
  analyticsFromBet: 'Ver gráficos',
  chipCustom: 'Outro valor',
  customAmount: 'Outro valor',
  enterAmount: 'Digite o valor',
  customAmountInvalid: 'Digite um valor dentro do limite da sala.',
  placeBet: 'Apostar',
  pool: 'Prêmio',
  previewRoom: 'Ver sala',
  preferenceActivityOff: 'Notificações de atividade desligadas',
  preferenceActivityOn: 'Notificações de atividade ligadas',
  preferenceLeaderboardOff: 'Ranking público desligado',
  preferenceLeaderboardOn: 'Ranking público ligado',
  preferencesFailed: 'Não foi possível salvar a preferência',
  preferencesSaved: 'Preferência salva',
  register: 'Criar conta',
  refresh: 'Atualizar',
  remove: 'Remover',
  retry: 'Tentar de novo',
  roomPool: 'Pool da sala',
  roomIntroTitle: 'Prévia da sala',
  thisRoundBets: 'nesta rodada',
  introHost: 'Sala apresentada por',
  roomHostDefault: 'Equipe Sorteia',
  introLimits: 'Limites de aposta',
  introPerRoundRange: 'Sua aposta por rodada',
  introPoolCap: 'Limite total de apostas da rodada',
  introMinVip: 'VIP mínimo',
  introVipFree: 'Livre',
  introCashback: 'Cashback da sala',
  introCashbackMin: 'Em apostas de %v% ou mais',
  introPerks: 'Vantagens',
  introEnter: 'Entrar na sala',
  introFull: 'Lotada · tente mais tarde',
  introVipShort: 'Precisa ser VIP %vip% · você é VIP %my% (faltam %exp% EXP)',
  introSoon: 'Em breve',
  tourTitle1: 'Escolha uma sala',
  tourBody1: 'Cada sala tem seus próprios limites e nível VIP. Toque para ver os detalhes.',
  tourTitle2: 'Faça uma aposta',
  tourBody2: 'Toque fichas para acumular sua aposta. A rodada fecha a cada 5 minutos.',
  tourTitle3: 'Verifique on-chain',
  tourBody3: 'Cada resultado pode ser conferido por qualquer pessoa. Toque em "Sorteio justo" para saber mais.',
  tourSkip: 'Pular',
  tourNext: 'Próximo',
  tourDone: 'Entendi',
  introOnline: 'Online',
  accessLocked: 'Só VIP %vip%',
  roomSingular: 'sala',
  tier_bronze: 'Bronze',
  tier_silver: 'Prata',
  tier_gold: 'Ouro',
  tier_diamond: 'Diamante',
  tier_black: 'Black Card',
  introPerkFastPix: 'Prêmio no Pix, em reais',
  introPerkFastPixNoPix: 'Prêmio direto na sua conta',
  introPerkActiveRoom: 'Sala ativa nesta rodada',
  introPerkVipRoom: 'Sala com acesso VIP',
  introRecentDraws: 'Últimos resultados',
  introRecentDrawsEmpty: 'Resultados recentes ainda indisponíveis.',
  introOpenArchive: 'Arquivo',
  perkHost: 'Apresentador ao vivo',
  roomBetsOpen: 'Ver apostas',
  roomBetsTitle: 'Nesta rodada',
  roomBetsSubtitle: '%n% apostas · fecha em %time%',
  roomBetsBreakdown: '💰 Onde está o dinheiro',
  roomBetsWeightBy: 'Ver por',
  roomBetsWeightMoney: 'Dinheiro',
  roomBetsWeightPeople: 'Pessoas',
  roomBetsVsLast: 'vs. última',
  roomBetsPrevRef: 'última rodada %pool%',
  roomBetsPairWeight: '%pair% de %total% nesta rodada',
  roomBetsNoSideYet: 'sem dinheiro ainda',
  roomBetsQuietTitle: 'Rodada tranquila — sem apostas ainda',
  roomBetsQuietSub: 'Seja o primeiro, ou veja as últimas rodadas antes de apostar.',
  roomBetsQuietTrendCta: 'Ver resultados recentes →',
  roomBetsQuietPrev: 'Última rodada: %pool% · %n% pessoas',
  roomBetsFilteredOf: '%n% de %total%',
  roomBetsUntouched: '%n% sem apostas · toque para apostar',
  roomBetsHistWindow: 'Últimas %n% rodadas',
  roomBetsHistOverdue: 'Há mais tempo sem sair',
  roomBetsHistGap: '%n% rodadas',
  roomBetsCapShort: 'limite %cap%',
  betOnPick: 'Apostar em %pick%',
  roomBetsAll: 'Todas as apostas',
  roomBetsAllLoaded: '%n% no total',
  roomBetsRecent: 'Apostas recentes',
  roomBetsRecentLimited: 'últimas 50',
  roomBetsShowNumbers: 'Ver por número',
  roomBetsPeople: 'pessoas',
  roomBetsHideNumbers: 'Ocultar números',
  roomBetsNoBets: 'Sem apostas ainda · seja o primeiro.',
  roomBetsHiddenGuest: 'Visitantes veem nomes protegidos até entrar na conta.',
  roomBetsPoolCap: 'Limite total de apostas',
  roomBetsPotential: 'Retorno potencial',
  roomBetsGridLastdigit: 'Números específicos',
  roomBetsGridSicbo: 'Um dado',
  roomBetsGridRoulette: 'Número único',
  roomBetsFilter: 'Filtrar apostas',
  roomBetsSortBy: 'Ordenar por',
  roomBetsSortRecent: 'Recentes',
  roomBetsSortAmount: 'Maior aposta',
  roomBetsSortBettor: 'Quem apostou mais',
  roomBetsBetOne: '1 aposta',
  roomBetsBetN: '%n% apostas',
  roomBetsFilterAll: 'Todas',
  roomBetsFilterMine: 'Minhas',
  roomBetsCountLabel: 'Apostas',
  roomBetsGridEmpty: 'Ninguém apostou em número exato ainda — a grade acende com a primeira aposta.',
  roomBetsPersonOne: 'pessoa',
  roomBetsFilteredCountOne: '1 aposta',
  roomBetsFilteredCount: '%n% apostas',
  roomBetsFilterEmpty: 'Nenhuma aposta neste filtro.',
  recentDrawsTitle: 'Sorteios recentes',
  recentDrawsHint: 'hoje + ontem · toque para conferir · arraste para fechar',
  today: 'Hoje',
  yesterday: 'Ontem',
  drawsCount: '%n% sorteios',
  olderInArchive: 'Quer ver rodadas mais antigas? Abra o Histórico de sorteios.',
  openArchiveFull: 'Abrir histórico completo',
  drawDetailDigits: 'Dígitos extraídos',
  drawDetailBlockDigits: 'Linhas dos blocos',
  drawDetailBlockDigitsHint: 'Cada linha mostra os 10 últimos dígitos extraídos do hash público antes da soma coluna a coluna.',
  drawDetailFairness: 'O resultado é calculado a partir de blocos públicos e pode ser auditado depois do fechamento.',
  drawDetailProof: 'Prova pública',
  drawDetailNoProof: 'Prova ainda não disponível para esta rodada.',
  cutoffLabel: 'Encerramento',
  yourTimeLabel: 'Seu horário',
  localTimeTag: 'Local',
  drawVerifyTitle: 'Verifique o resultado',
  drawVerifyStepDigits: 'Os blocos públicos geraram D = %d%.',
  drawVerifyStepMissing: 'Dados de verificação ainda não disponíveis nesta rodada.',
  drawVerifyLastdigit: 'Último Dígito usa D1. D1 = %d1%, resultado = %result%.',
  drawVerifySicbo: 'Sic Bo usa três grupos de 3 dígitos: %steps%.',
  drawVerifyRoulette: 'Roleta soma os três grupos: (%sum%) ÷ 37, sobra %result%.',
  drawVerifyDerivation: 'Como o resultado saiu',
  drawVerifyColumnSum: 'Soma',
  drawVerifyModuloHint: 'Cada coluna guarda só o último dígito da soma para formar D1-D10.',
  drawVerifyGameOutputs: 'Resultado',
  verifyExpand: 'Mostrar passos',
  verifyCollapse: 'Esconder passos',
  drawAnchorWhyTitle: 'Por que estes 3 blocos?',
  drawAnchorWhyBody: 'Depois do encerramento em %time%, o sistema usa os 3 primeiros blocos públicos disponíveis.',
  drawAnchorReasonLockedTitle: 'Apostas já travadas',
  drawAnchorReasonLockedBody: 'As escolhas ficam fechadas antes de qualquer hash desses blocos existir.',
  drawAnchorReasonPublicTitle: 'Fonte pública',
  drawAnchorReasonPublicBody: 'Os hashes podem ser conferidos em exploradores Ethereum e a conta pode ser refeita.',
  verifyEtherscan: 'Ver últimos blocos no Etherscan',
  verifyFooter: 'Qualquer pessoa pode refazer a conta numa calculadora. Se o seu resultado não bater com o nosso, você nos pegou.',
  etherscanHelpTitle: 'Verificar Bloco #%n% no Etherscan',
  etherscanHelpBody: 'Etherscan é o explorador público da Ethereum. Use o link abaixo para conferir que o hash bate.',
  etherscanHelpUrlLabel: 'Endereço do bloco',
  etherscanHelpCopy: 'Copiar link',
  etherscanHelpOpen: 'Abrir no Etherscan ↗',
  etherscanHelpClose: 'Fechar',
  etherscanHelpTip: 'Dica: depois que o Etherscan carregar, role até "More Details" e toque em "+ Click to show more". O hash do bloco aparece na PRIMEIRA linha da seção expandida.',
  etherscanCopyOk: 'Link copiado',
  etherscanCopyFail: 'Não foi possível copiar',
  tickerWin: '🎉 %name% ganhou %amount% em "%pick%"',
  feedOn: 'Feed ao vivo ativo',
  feedOff: 'Feed ao vivo desativado',
  feedMin: 'Só o resumo',
  roomTourTitle1: 'Pool da rodada',
  roomTourBody1: 'Veja em tempo real quanto a sala já apostou nesta rodada.',
  roomTourTitle2: 'Últimos 5 resultados',
  roomTourBody2: 'Toque aqui para ver tendência, números atrasados e mapa.',
  roomTourTitle3: 'Faça sua aposta',
  roomTourBody3: 'Toque em APOSTAR para escolher fichas e seu lado. Sem teclado — só fichas.',
  roomTourTitle4: 'Chat e menu',
  roomTourBody4: 'Converse com a galera ou abra o menu lateral (histórico, minhas apostas etc.).',
  roomTourSkip: 'Pular',
  roomTourNext: 'Próximo',
  roomTourDone: 'Entendi',
  rgTitle: 'Jogo responsável',
  rgIntro: 'Contamos o tempo desde que você entrou e avisamos a cada hora.',
  rgSession: 'Tempo de sessão',
  rgSessionBody: 'Uma pausa curta ajuda a manter o jogo sob controle.',
  sessionMinutes: 'Jogando há {{m}} min',
  sessionReminderTitle: 'Pausa consciente',
  sessionReminderBody: 'Você está jogando há {{time}}. Faça uma pausa curta ou revise seus limites.',
  sessionReminderContinue: 'Continuar jogando',
  sessionReminderLimits: 'Revisar limites',
  rgLimitDescTitle: 'Limites de aposta',
  rgLimitDesc: 'Limite de perda líquida por período. Apostas que ultrapassem o limite são bloqueadas.',
  rgDailyLimit: 'Limite diário',
  rgWeeklyLimit: 'Limite semanal',
  rgMonthlyLimit: 'Limite mensal',
  rgDailyUsed: 'Usado hoje',
  rgWeeklyUsed: 'Usado na semana',
  rgMonthlyUsed: 'Usado no mês',
  rgDailyRemaining: 'Restante',
  rgLimitPending: 'Limite maior entra em vigor depois',
  rgLimitSaveFailed: 'Não foi possível salvar o limite',
  rgLoadError: 'Não foi possível carregar limites',
  rgSaveLimits: 'Salvar limites',
  rgCoolOff: 'Pausar a conta',
  rgCoolOffPick: 'Escolha o tempo de pausa',
  rgCoolOff24h: '24 horas',
  rgCoolOff7d: '7 dias',
  rgCoolOff30d: '30 dias',
  rgCoolOff60d: '60 dias',
  rgCoolOffSet: 'Pausa configurada · {{d}} dia(s)',
  rgCoolOffActive: 'Pausa ativa',
  rgCoolOffDesc: 'Pausa sua conta — sem depósitos nem apostas — pelo período escolhido.',
  roomComingSoon: 'Em breve',
  roomEntry: 'Entrada',
  roomFull: 'Lotada',
  switchRoomTitle: 'Trocar de sala',
  switchRoomDesc: 'Pule para qualquer outra sala — sem voltar ao lobby',
  switchRoomEmpty: 'Nenhuma outra sala disponível agora',
  switchRoomCurrent: '(atual)',
  roomLoadError: 'Não foi possível carregar as salas',
  roomLoadErrorBody: 'Verifique sua conexão e tente de novo.',
  roomsPlural: 'salas',
  refreshing: 'Atualizando…',
  releaseToRefresh: 'Solte para atualizar',
  roundLimit: 'Rodada',
  roundNotOpen: 'Sorteando · aguarde a próxima rodada',
  heatRailTitle: 'Em destaque agora',
  heatStreak: '%n% seguidas',
  heatMultiple: '%n%× a média',
  heatQuente: 'quente agora',
  roundSettled: 'Rodada liquidada',
  settlementTitle: 'Resultado da rodada',
  summaryTitle: 'Resultado da rodada #%round%',
  summaryYouWon: 'Você ganhou',
  summaryBreakEven: 'Empatou nesta rodada',
  summaryDrawHeadline: 'Rodada #%round% saiu %value%',
  summaryNetLine: 'Saldo da rodada %amount%',
  summarySettling: 'Liquidando…',
  summaryAutoClose: 'Fecha em %s%s',
  bannerRoundResult: 'Rodada #%round%: %value%',
  bannerSettling: 'Rodada #%round% liquidando…',
  bannerCredited: 'Rodada #%round% %amount% creditado',
  bannerCorrected: 'Rodada #%round% liquidação corrigida para %amount%',
  bannerView: 'Ver',
  summaryClose: 'Fechar',
  summaryHistory: 'Ver histórico',
  summaryShowMore: '+%n% apostas',
  summaryShowLess: 'Mostrar menos',
  pending: 'Pendente',
  cancel: 'Cancelar',
  send: 'Enviar',
  messageBlocked: 'Mensagem bloqueada',
  messageTooLong: 'Mensagem muito longa',
  voiceRecording: 'Gravando…',
  voiceSlideCancel: 'arraste para cancelar',
  voiceUnavailable: 'Mensagem de voz indisponível',
  voiceFormatUnsupported: 'Este formato de áudio não é compatível com este dispositivo',
  voiceUnsupported: 'Gravação de áudio indisponível neste navegador',
  voicePermissionRequired: 'Permita acesso ao microfone para gravar',
  voiceTooShort: 'Áudio muito curto',
  voiceTooBig: 'Áudio muito grande',
  voiceSent: 'Áudio enviado',
  showPassword: 'Mostrar senha',
  signOut: 'Sair',
  statPlayOne: 'jogada',
  statPlays: 'jogadas',
  statWin: 'vitórias',
  submitting: 'Aguarde...',
  stake: 'Apostado',
  stagedBets: 'Apostas selecionadas',
  return: 'Retorno',
  tapPickToStage: 'Toque em uma opção para adicionar a ficha selecionada.',
  net: 'Resultado',
  view: 'Ver',
  vip: 'VIP',
  vipTooLow: 'Seu VIP ainda não libera esta sala',
  wallet: 'Carteira',
  walletBalanceAfterShort: 'após',
  walletDepositUnavailable: 'Depósitos em %currency% estão indisponíveis no momento. Entre em contato com o suporte.',
  walletWithdrawUnavailable: 'Saques em %currency% estão indisponíveis no momento. Entre em contato com o suporte.',
  walletChannelUnavailable: 'Canal indisponível',
  walletDeposit: 'Depositar',
  walletEyebrow: 'Saldo',
  walletEmptyBody: 'Adicione saldo para começar a jogar.',
  walletEmptyCta: 'Fazer primeiro depósito',
  walletEmptyFiltered: 'Nenhuma movimentação com este filtro ainda.',
  walletEmptyTitle: 'Sua carteira está esperando o primeiro movimento',
  walletFiatSub: 'Saldo total',
  walletRefRaffle: 'Prêmio do sorteio',
  walletCashWithdrawable: "Disponível para saque",
  walletCashLocked: "Bloqueado",
  walletRolloverEyebrow: 'Rollover',
  walletNextUnlockBet: 'Falta apostar %v%',
  walletNextUnlockGain: 'libera %a% para saque',
  walletLockedInclBonus: 'inclui bônus %b%',
  walletAllAvailable: 'Tudo disponível para saque',
  auditCashExhausted: "Saldo da origem esgotado",
  auditCashExhaustedNote: "Não há saldo nesta origem nem apostas pendentes. A exigência de apostas foi encerrada.",
  auditEnded: "Exigência encerrada",
  auditEndedNote: "Esta origem não tem mais uma exigência de apostas ativa.",
  walletAuditSeeDetails: 'Ver progresso',
  walletLockTitle: 'Saque libera depois do rollover',
  walletLockBody: 'Proteção antifraude: cada depósito precisa ser apostado antes do saque. Complete as apostas e o valor fica disponível para saque.',
  walletFiat: 'Carteira · %currency%',
  walletFilterAll: 'Tudo',
  walletFilterBet: 'Apostas',
  walletFilterDeposit: 'Depósitos',
  walletFilterInfoDep: 'Apenas depósitos concluídos. Pendentes ou recusados ficam em Transações.',
  walletFilterInfoWdr: 'Apenas saques concluídos. Pendentes ou recusados ficam em Transações.',
  walletFilterReward: 'Recompensas',
  walletFilterWithdraw: 'Saques',
  walletTrackOrder: 'Ver pedido',
  pedidosDetailSheetTitle: 'Detalhes do pedido',
  pedidosDetailIdMerchant: 'ID do pedido',
  pedidosDetailIdProvider: 'ID no provedor de pagamento',
  pedidosDetailChannel: 'Canal',
  pedidosDetailCreated: 'Criado',
  pedidosDetailPaidAt: 'Pago em',
  pedidosDetailExpiresAt: 'Expira em',
  pedidosDetailHelpPending: 'Aguardando a confirmação do pagamento. Normalmente até 30 minutos.',
  pedidosDetailHelpFailed: 'Este pedido não foi concluído. Fale com o suporte se o dinheiro saiu da sua conta.',
  pedidosDetailHelpCompleted: 'Concluído. O valor já está na sua carteira.',
  pedidosDetailContactCta: 'Falar com suporte',
  pedidosTimelineCreated: 'Pedido criado',
  pedidosTimelineReview: 'Revisão do pedido',
  pedidosTimelineCompleted: 'Concluído',
  pedidosTimelineFailed: 'Falhou',
  pedidosReceiptKeep: 'Guarde o comprovante. Se o crédito não aparecer, envie ao suporte pelo chat.',
  pedidosReceiptUploadQueued: 'Envio de comprovante em breve',
  pedidosReceiptUploadHint: 'Por enquanto, envie o comprovante pelo suporte.',
  pedidosReceiptSendSupport: 'Enviar pelo suporte',
  pedidosEmptyFiltered: 'Nenhum pedido com este filtro.',
  pedidosPendingHint: 'Análise normalmente até 30 minutos.',
  pedidosStatusAll: 'Todos',
  pedidosStatusCompleted: 'Concluídos',
  pedidosStatusFailed: 'Recusados',
  pedidosStatusPending: 'Pendentes',
  pedidosTabDeposits: 'Depósitos',
  pedidosTabWithdraws: 'Saques',
  unpaidPageTitle: 'Depósitos não concluídos',
  unpaidOlderNotice: 'Pedidos com mais de 3 dias não aparecem aqui. Fale com o suporte.',
  unpaidEmpty: 'Nenhum depósito para resolver.',
  unpaidSeeExample: 'Onde encontro o código?',
  unpaidCodeTitle: 'Cole o código de 22 caracteres',
  unpaidUpload: 'Enviar foto do comprovante',
  unpaidFileHint: 'JPG, PNG, PDF',
  unpaidRemoveFile: 'Remover',
  unpaidSubmit: 'Enviar comprovante',
  unpaidSending: 'Enviando…',
  unpaidYourSubmission: 'O que você enviou',
  unpaidReceiptMissing: 'Sem foto do comprovante',
  unpaidViewReceipt: 'Ver comprovante',
  unpaidResubmitHint: 'Confira o motivo e envie novamente.',
  unpaidRecoverCta: 'Enviar comprovante',
  unpaidErrRequired: 'Informe o código ou anexe um comprovante.',
  unpaidErrInvalid: 'O código deve ter exatamente 22 letras ou números.',
  unpaidErrUsed: 'Este código já está associado a outro depósito. Fale com o suporte.',
  unpaidErrLimit: 'Limite de envios atingido. Fale com o suporte.',
  unpaidErrClosed: 'Este depósito já foi processado.',
  unpaidErrFile: 'Não foi possível ler o arquivo. Use JPG, PNG, WebP ou PDF de até 10 MB.',
  unpaidErrGeneric: 'Não foi possível concluir. Tente novamente.',
  unpaidBadgeAria: '%n% depósitos para resolver',
  unpaidStepPaid: 'Pago',
  unpaidStepProof: 'Comprovante enviado',
  unpaidStepCredited: 'Creditado',
  unpaidStepNow: 'Agora',
  unpaidStepEta: '~15 min',
  unpaidStepCrediting: 'Creditando',
  unpaidStepRejected: 'Comprovante recusado',
  unpaidOr: 'ou',
  unpaidResubmit: 'Enviar de novo',
  unpaidSupportLink: 'Precisa de ajuda? Falar com o suporte',
  unpaidReviewTitle: 'Estamos confirmando com a operadora de pagamento',
  unpaidReviewBody: 'Normalmente leva menos de 15 minutos. Avisamos quando entrar.',
  unpaidVerifiedTitle: 'Comprovante aprovado — creditando o depósito',
  unpaidVerifiedBody: 'Sua carteira atualiza em instantes.',
  unpaidYourSubmissionBefore: 'O que você enviou antes',
  unpaidRejectedTitle: 'Não conseguimos validar este comprovante',
  unpaidRejectedReason: 'O suporte diz: %note%',
  unpaidRejectedAction: 'Envie de novo abaixo.',
  unpaidCreditedTitle: 'Comprovante aprovado — %amount% creditado',
  unpaidCreditedBody: 'Sua carteira está atualizada.',
  unpaidPageIntroA: 'Pagou e não caiu? Envie o comprovante. Normalmente creditado em até',
  unpaidPageIntroEta: '15 minutos.',
  historyStatusWaitingPayment: 'Aguardando pagamento',
  pedidosTimelineGateway: 'Confirmação do pagamento',
  pedidosTimelineCredited: 'Creditado na carteira',
  historyMoreDetails: 'Mais detalhes',
  historyStatusProofReview: 'Comprovante em análise',
  receiptExTitle: 'Exemplos de comprovante',
  receiptExSub: 'Toque no seu banco para ver um comprovante real e o nome do campo a procurar.',
  receiptExOthers: 'Outros',
  receiptExMpWarning: 'Esta tela também pode mostrar "N° de movimiento", que não é o código certo. Procure o "Código de identificación" de 22 caracteres.',
  receiptExCalled: 'ESTE CÓDIGO SE CHAMA:',
  receiptExCalledList: '"Código de identificación" no Mercado Pago · "ID Operación" no Lemon · "COELSA ID" no Brubank · "N° de operación" no Banco Macro / Santander · "Identificador de Transferencia" no Banca Empresas · "Código de operación" no Naranja X',
  receiptExOthersIntro: 'O número a informar é um código de 22 caracteres (letras e números) que aparece no seu comprovante de transferência.',
  receiptExOthersNames: 'Pode aparecer com um destes nomes:',
  receiptExOthersOutro: 'Copie o código completo de 22 caracteres e cole no campo.',
  receiptExNoBank: 'Não encontra seu banco? Fale com o suporte.',
  receiptExGotIt: 'Entendi',
  receiptExImgAlt: 'Comprovante de %bank% com o código de 22 caracteres destacado',
  walletTabRecent: 'Transações',
  walletViewAllHistory: 'Ver todo o histórico de transações',
  historyEmptyDeposits: 'Nenhum depósito ainda.',
  historyEmptyWithdrawals: 'Nenhum saque ainda.',
  historyWithdrawNet: 'Recebe %net% · taxa %fee%',
  historyOrderNotFound: 'Não encontramos este pedido.',
  historyBackToList: 'Voltar ao histórico',
  historyToday: 'Hoje',
  historyYesterday: 'Ontem',
  depositReturnTitle: 'Confirmando o depósito…',
  depositReturnBody: 'Normalmente entra em poucos minutos. Aguarde.',
  depositReturnNotReceived: 'Já paguei, mas não caiu',
  depositReturnLater: 'Ver depois',
  depositNoticeTitle: 'Aviso importante',
  depositNoticeBody: 'Guarde o comprovante da transferência: depois você informa aqui (código de 22 caracteres ou foto) para verificarmos o pagamento.',
  depositNoticeSupport: 'Pagou e não caiu? Falar com o suporte',
  transactionRecordId: 'ID',
  transactionKindDeposit: 'Depósito',
  transactionKindWithdrawal: 'Saque',
  transactionFeeShort: 'Taxa',
  transactionNetShort: 'Líquido',
  transactionDepositAmount: 'Valor do depósito',
  transactionPaymentAmount: 'Valor pago',
  transactionWithdrawAmount: 'Valor do saque',
  transactionWithdrawFee: 'Taxa do saque',
  transactionActualAmount: 'Valor líquido',
  transactionDate: 'DATA',
  transactionStatusSuccess: 'Concluído',
  transactionStatusInProgress: 'Em andamento',
  transactionStatusError: 'Erro',
  walletLoadMore: 'Carregar mais 30',
  walletNoOrders: 'Nenhum pedido ainda.',
  walletRefreshFailed: 'Não foi possível carregar a carteira.',
  paymentStatusRejected: 'Recusado',
  paymentStatusCancelled: 'Cancelado',
  paymentStatusExpired: 'Expirado',
  paymentStatusReview: 'Em análise',
  paymentStatusPayout: 'Pagamento em andamento',
  walletStatusCompleted: 'Concluído',
  walletStatusFailed: 'Falhou',
  walletStatusPending: 'Pendente',
  walletTabBilhetes: 'Bilhetes',
  walletTabExtrato: 'Extrato',
  walletTabOrders: 'Pedidos',
  walletTicketsPending: 'Bilhetes e sorteios serão migrados para esta área.',
  walletTicketsLoadError: 'Não foi possível carregar bilhetes.',
  walletBilhetesActive: 'Bilhetes ativos',
  walletBilhetesExpiring: 'Expiram em <24h',
  walletBilhetesActiveRaffle: 'Sorteio em andamento',
  bilhetesSubActive: 'Ativos',
  bilhetesSubHistory: 'Histórico',
  bilhetesOrigemSummary: 'Origens:',
  bilhetesHistoricoEmpty: 'Nenhum bilhete usado ou expirado ainda.',
  bilhetesTicketIssued: 'Recebido',
  bilhetesTicketExpires: 'expira',
  bilhetesTabResults: 'Resultados',
  bilhetesTabTickets: 'Bilhetes',
  bilhetesTabHistory: 'Histórico',
  bilhetesEarnCta: 'Ganhar bilhetes',
  bilhetesWonBanner: 'Você ganhou %v% nos últimos sorteios 🎉',
  bilhetesResultsEmpty: 'Seus resultados aparecem aqui depois de cada sorteio.',
  bilhetesResultsEmptyCta: 'Ver sorteios',
  bilhetesHistoryEmpty: 'Nenhuma movimentação de bilhetes ainda.',
  bilhetesResultVoided: 'Cancelado',
  bilhetesResultAwaiting: 'Aguardando',
  bilhetesResultOpen: 'Inscrito',
  bilhetesResultMyTicketsOne: 'Você: 1 bilhete',
  bilhetesResultMyTicketsMany: 'Você: %n% bilhetes',
  bilhetesResultRefundedOne: '1 devolvido',
  bilhetesResultRefundedMany: '%n% devolvidos',
  raffleDayToday: 'hoje',
  raffleDayYesterday: 'ontem',
  ticketExpiringSoon: 'Expira em',
  ticketHowToEarn: 'Como ganhar mais bilhetes →',
  ticketSource_reward_first_deposit: '1º depósito',
  ticketSource_reward_invite_deposit: 'Indicação + depósito',
  ticketSource_reward_daily_5rounds: '5 rodadas no dia',
  ticketSource_reward_3day_streak: '3 dias seguidos',
  ticketSource_reward_first_bet_app: '1ª aposta no app',
  ticketSource_unknown: 'Bilhete',
  ticketSource_reward_winner: 'Prêmio do sorteio',
  ticketSource_bonus: 'Bônus',
  ticketSource_claim_reward: 'Recompensa resgatada',
  ticketSource_reward_phone_verified: 'Telefone verificado',
  ticketSource_reward_email_verified: 'E-mail verificado',
  ticketTxRefundNote: 'sorteio cancelado',
  ticketTxBalanceAfter: 'saldo %n%',
  ticketStatus_active: 'Ativo',
  ticketStatus_consumed: 'Usado',
  ticketStatus_expired: 'Expirado',
  ticketStatus_refunded: 'Devolvido',
  ticketStatus_unknown: 'Status',
  raffleRecentResults: 'Resultados recentes',
  raffleEventEnded: 'Sorteio expirado',
  raffleResultUnavailable: 'Resultado indisponível. Tente novamente.',
  raffleRoundAt: 'Sorteio das',
  raffleEntriesShort: 'inscritos',
  raffleVerifyTitle: 'Resultado do sorteio',
  raffleResultTitle: 'Resultado',
  raffleWonTitle: 'Você ganhou!',
  raffleCreditedWallet: 'Na sua carteira · Pix',
  raffleCreditedWalletNoPix: 'Na sua carteira',
  raffleNotWonMsg: 'Seus %n% números não saíram. Bilhetes são de graça — tem sempre um novo sorteio.',
  raffleDrawnNumber: 'Número sorteado',
  raffleFairRow: 'Sorteio justo · você pode conferir',
  raffleFairIntro: 'O resultado vem de dígitos públicos depois do fechamento. Ninguém controla — nem a gente.',
  raffleTabWinners: 'Ganhadores',
  raffleTabEntries: 'Inscrições',
  raffleEntriesFull: 'Lotado',
  raffleVoidedReasonMin: 'Menos que o mínimo de %n% inscritos. O sorteio não aconteceu.',
  raffleVoidedReasonGeneric: 'O sorteio foi cancelado.',
  raffleTicketsReturned: 'Bilhetes devolvidos: %n%',
  raffleTicketsReturnedHint: 'Bilhetes devolvidos não expiram — use no próximo sorteio.',
  raffleNextDraw: 'Próximo sorteio',
  raffleHitMark: '✓ %v%',
  raffleHowItWorksLink: 'Como funciona',
  raffleSeed: 'Semente D₁..D₁₀',
  raffleConcatLabel: 'D =',
  raffleWinnersList: 'Ganhadores',
  raffleEtherscanCta: 'Etherscan',
  raffleVerifyCta: 'Verificar manualmente',
  raffleContinue: 'Continuar',
  raffleYouWonLabel: 'Você ganhou',
  raffleVerifyStepPending: 'Resultado aguardando dígitos públicos.',
  raffleVoidedTitle: 'Sorteio cancelado',
  raffleVoidedRefunded: 'Bilhetes devolvidos · não atingiu o mínimo',
  raffleVoidedRefundedDetail: '%n% bilhete(s) devolvido(s) à sua carteira de bilhetes.',
  raffleAlreadyEntered: 'Você está inscrito',
  raffleAddTicketsCta: 'Adicionar bilhetes',
  raffleEntryLimitReached: 'Seu limite neste sorteio foi atingido',
  raffleFullNoticeTitle: 'Este sorteio lotou',
  raffleFullNoticeBody: 'As vagas foram preenchidas antes da sua inscrição. Seus bilhetes continuam válidos para o próximo sorteio.',
  raffleFullNoticeCta: 'Ver quem entrou',
  raffleHourlyTitle: 'Sorteio diário',
  raffleDrawsIn: 'Sorteio em',
  raffleHeroSummary: '%pool% em prêmios · %winners% ganhadores',
  raffleEntriesNow: 'inscritos agora',
  rafflePrizeTotal: 'no total',
  raffleRewardBundle: 'Pacote de prêmios',
  raffleEntriesNeeded: 'Faltam %n% inscrições para o sorteio acontecer',
  raffleMinimumReached: 'Mínimo atingido · sorteio confirmado',
  raffleTrustCompact: 'Sorteio público · você pode verificar',
  raffleVerified: 'Verificado',
  raffleTicketBalance: 'Você tem %n% bilhete(s)',
  raffleEarnMore: 'Ganhar mais →',
  raffleWinnerSingle: '%n% ganhador',
  raffleWinnerMany: '%n% ganhadores',
  raffleTicketShort: 'bilhete(s)',
  raffleDepositCoupon: 'Cupom de depósito',
  raffleMaxTicketsAvailable: 'Disponível',
  raffleMyEntriesShort: 'Meus números',
  raffleNoTickets: 'Sem bilhetes — ganhe primeiro',
  raffleNoPrize: 'Sem prêmio',
  raffleWinTitle: 'VOCÊ GANHOU!',
  raffleWinCredited: '✓ Creditado na sua carteira em reais',
  raffleNotThisTime: 'Dessa vez não foi',
  raffleFirstWinner: '1º foi %serial% · %n% ganhador(es)',
  raffleLoseEncourage: 'Tem sorteio todo dia. Continue ganhando bilhetes!',
  raffleViewMyTickets: 'Meus bilhetes',
  raffleParticipantsEmpty: 'Nenhuma inscrição encontrada.',
  raffleParticipantsList: 'Inscrições do sorteio',
  raffleParticipantsSearch: 'Buscar número ou nome de usuário',
  raffleParticipantsSummary: '%entries% inscrições · %players% participantes',
  raffleEntriesOverview: 'Resumo das inscrições',
  rafflePublicLedger: 'Lista pública e verificável',
  raffleYourEntries: 'Suas inscrições',
  raffleEntriesFilter: 'Filtrar inscrições',
  raffleEntriesAll: 'Todas',
  raffleEntriesMine: 'Minhas',
  raffleSearchResults: '%n% resultados',
  raffleUnknownPlayer: 'Usuário indisponível',
  raffleOpenProfile: 'Ver perfil público de %username%',
  raffleEnteredAt: 'Inscrição às %time%',
  rafflePrizeHeading: 'Prêmios',
  raffleRegisterCount: 'Bilhetes para inscrever',
  raffleRegisterCta: 'Confirmar inscrição',
  raffleRegisterError: 'Não foi possível entrar no sorteio. Tente novamente.',
  raffleTicketsEmptyCta: 'Como obter bilhetes →',
  raffleTicketsEmptyTitle: 'Você ainda não tem bilhetes.',
  raffleTicketsOriginHint: 'Ganhos por recompensas · não expiram',
  raffleTrustTitle: 'Como o sorteio é justo',
  raffleTrustPublic: 'O resultado vem de dígitos públicos depois do fechamento.',
  raffleTrustTickets: 'Bilhetes não são vendidos: vêm de atividades e recompensas.',
  raffleTrustExpiry: 'Se o mínimo não for atingido, os bilhetes voltam automaticamente.',
  raffleRulesLink: 'Ver regras',
  raffleConfirmIrrev: 'Depois de confirmar, você não pode cancelar. Se o mínimo do sorteio não for atingido, seus bilhetes voltam automaticamente.',
  raffleConfirmIrrevShort: 'Não dá pra cancelar. Se não atingir o mínimo, seus bilhetes voltam.',
  raffleQtyQuestion: 'Quantos números?',
  raffleQtyMax: 'Máx %n%',
  raffleBalanceLine: 'Você tem %have% · usar %use% · ficam %left%',
  raffleReceiveNumbers: '%n% números',
  raffleMinRemaining: 'Faltam %n% para o sorteio',
  raffleMinReachedShort: 'Mínimo atingido · sorteio confirmado',
  raffleEnterNumbersCta: 'Entrar · %n% números',
  raffleAddNumbersCta: 'Adicionar · %n% números',
  raffleConfirmedTitle: 'Números garantidos',
  raffleAddedTitle: '+%n% números',
  raffleYourNumbersLabel: 'Seus números',
  raffleNumbersWonSummary: '%h% de %m% números premiados · %v%',
  raffleAllYoursLabel: 'Todos os seus (%n%)',
  raffleNewTag: 'NOVO',
  raffleBalanceAfter: 'Usou %use% · restam %left% bilhete(s)',
  raffleMinPending: 'Vale quando atingir o mínimo · %cur%/%min%',
  raffleMinConfirmed: 'Sorteio confirmado',
  rafflePublicNumber: 'Seu número é público · dá pra conferir',
  raffleWatchCta: 'Acompanhar o sorteio',
  raffleAddMoreCta: 'Adicionar mais números',
  raffleCloseSheet: 'Fechar',
  raffleViewFullResult: 'Ver resultado completo',
  raffleRevealDrawing: 'Revelando ganhador',
  raffleRevealFirstSerial: 'Primeiro número: %serial%',
  raffleRevealFormula: 'D escolhe 1 de %n% · %k% prêmio(s)',
  raffleViewParticipants: 'Ver lista de participantes',
  raffleViewWinners: 'Ver ganhadores',
  raffleWinnersShort: 'ganhadores',
  raffleYou: 'Você',
  walletTrustBanks: '12+ bancos',
  walletTrustRegulated: 'Regulado pelo BC',
  walletTrustSpeed: 'Pix em até 30s',
  walletTrustSpeedNoPix: 'Transferência creditada em minutos',
  walletWithdraw: 'Sacar',
  tx_bet: 'Aposta',
  tx_deposit: 'Depósito',
  tx_reward: 'Recompensa',
  tx_win: 'Prêmio',
  tx_withdraw: 'Saque',
  noBetsYet: 'Nenhuma aposta ainda · faça sua primeira!',
  top: 'Ranking',
  topEyebrow: 'Ranking',
  avisos: 'Avisos',
  avisosActionUnavailable: 'Este aviso não tem uma ação disponível agora.',
  avisosEmpty: 'Sem avisos ainda',
  avisosEmptyBody: 'Quando houver prêmios, mensagens ou atualizações, elas aparecem aqui.',
  avisosEyebrow: 'Notificações',
  avisosLoadError: 'Não foi possível carregar avisos',
  avisosLoadErrorBody: 'Verifique sua conexão e tente novamente.',
  betNetworkError: 'Sem conexão. Verifique a internet e tente de novo — nada foi debitado.',
  avisosMarkAllRead: 'Marcar tudo como lido',
  avisosToday: 'Hoje',
  avisosYesterday: 'Ontem',
  avisosTab: 'Avisos',
  avisosUntitled: 'Aviso',
  faqTab: 'FAQ',
  helpTitle: 'Precisa de ajuda?',
  helpChat: 'Falar com suporte',
  helpFaq: 'Perguntas frequentes',
  helpFaqSub: 'Como o sorteio é calculado · odds · limites de saque',
  supportRespTime: '~2 min de resposta',
  supportChatSub: 'Abra uma conversa com nossa equipe',
  supportOpening: 'Abrindo chat...',
  supportChatError: 'Não foi possível abrir o chat. Tente novamente.',

  // ── Central de ajuda · Feedback ──────────────────────────────────────────
  helpTab: 'Ajuda',
  feedbackTab: 'Feedback',
  supportChat24h: 'Atendimento 24h',
  supportChatAvgReply: 'Resposta em ~2 minutos',
  tgChannelTitle: 'Canal oficial no Telegram',
  tgChannelSub: 'Anúncios de sorteio · prévia de eventos · avisos de manutenção',
  businessTitle: 'Contato comercial',
  businessSub: 'Parcerias · compra de mídia · co-branding',
  businessCopy: 'Copiar',
  businessCopied: 'Copiado',
  feedbackNew: 'Enviar feedback',
  feedbackEmpty: 'Nenhum feedback ainda',
  feedbackEmptyBody: 'Conte pra gente o que não está funcionando — a resposta aparece aqui.',
  feedbackPlaceholder: 'Descreva o problema ou a sugestão…',
  feedbackImagesLabel: 'Adicionar imagens (opcional, até 3)',
  feedbackSubmit: 'Enviar',
  feedbackSubmitted: 'Enviado — respondemos em breve',
  feedbackStatusPending: 'Em andamento',
  feedbackStatusReplied: 'Respondido',
  feedbackStatusClosed: 'Encerrado',
  feedbackMine: 'Meu feedback',
  feedbackOfficialReply: 'Resposta oficial',
  feedbackAwaitingReply: 'Recebido — o suporte já está vendo isso',
  feedbackStillNeedHelp: 'Ainda precisa de ajuda? Fale com o suporte →',
  feedbackLoadMore: 'Carregar mais',
  feedbackErrTooShort: 'Escreva pelo menos 10 caracteres',
  feedbackErrTooLong: 'Máximo de 1000 caracteres',
  feedbackErrImageTooLarge: 'Imagem muito grande — escolha outra',
  feedbackErrImageType: 'Só aceitamos JPG, PNG ou WebP — escolha outro arquivo',
  feedbackErrRateLimited: 'Você já usou sua cota de feedback hoje. Tente amanhã ou fale com o suporte.',
  feedbackErrTooFrequent: 'Espere um instante antes de enviar de novo',
  feedbackErrSubmit: 'Não foi possível enviar — seu rascunho está salvo, tente de novo',
  feedbackLoginRequired: 'Entre na conta para enviar feedback',
  feedbackErrImagesNotSaved: 'Suas imagens não foram salvas — você vai precisar adicioná-las de novo',

  analyticsTitle: 'Análise',
  analyticsTabTrend: 'Tendência',
  analyticsTabCold: 'Atrasos',
  analyticsTabRoad: 'Mapa',
  analyticsTabFair: 'Justo',
  analyticsRounds: 'rodadas',
  analyticsLoadError: 'Não foi possível carregar a análise',
  analyticsEmpty: 'Sem rodadas suficientes para análise.',
  analyticsToBet: 'Apostar',
  analyticsTrendDesc: 'Cada ponto é uma rodada. Eixo Y é o dígito sorteado (0–9). A linha tracejada separa alto (5–9) de baixo (0–4).',
  analyticsTrendDescSicbo: 'Cada ponto é uma rodada. Eixo Y é a soma dos dados (3–18). Linha tracejada separa alto (11–17) de baixo (4–10); trincas em dourado.',
  analyticsTrendDescRoulette: 'Cada ponto é uma rodada. Eixo Y é o número da roda (0–36). Linha tracejada separa alto (19–36) de baixo (1–18); 0 é verde.',
  analyticsDirectionLabel: 'Da esquerda para a direita: resultados mais antigos até os mais recentes.',
  analyticsTrendScrollLabel: 'Gráfico de tendência rolável. Os resultados mais antigos ficam à esquerda e os mais recentes à direita.',
  analyticsTrendChartLabel: 'Gráfico de tendência com %n% rodadas.',
  analyticsThreshold: 'Linha alto / baixo',
  analyticsColdHeader: 'Atraso — rodadas desde que saiu',
  analyticsColdTapHint: 'Toque em qualquer quadro para abrir a aposta correspondente.',
  analyticsColdTapAria: 'Apostar em %pick%',
  analyticsColdMeanShort: 'média ≈ %n%',
  analyticsColdSubtitleSicbo: 'Cada seção abaixo tem seu próprio atraso esperado — veja o cabeçalho de cada uma.',
  analyticsColdSubtitleRoulette: 'Atraso médio ≈ 37 rodadas (1 chance em 37 por rodada).',
  analyticsColdHintSicbo: 'Categorias com atraso esperado maior (ex.: trinca específica em média ~215 rodadas) passam centenas de rodadas sem sair — é aleatoriedade normal, não um sinal de que "vai sair".',
  analyticsColdHintRoulette: '"3" = saiu 3 rodadas atrás. Cada número tem em média 1 chance em 37 por rodada; lacunas longas são aleatoriedade normal, não um sinal de que "está pra sair".',
  analyticsColdHint: '"3" = saiu 3 rodadas atrás. Cada dígito tem em média 1 chance em 10 por rodada; lacunas longas são aleatoriedade normal, não um sinal de que "está pra sair".',
  analyticsTheoretical: 'Atraso médio ≈ 10 rodadas (1 chance em 10 por rodada)',
  analyticsSortNatural: '0 → 9',
  analyticsSortDefault: 'Padrão',
  analyticsSortMissing: 'Mais atrasados',
  analyticsRoadDesc: 'Mesma cor empilha para baixo; cor diferente abre nova coluna. Últimas 35 colunas.',
  analyticsRoadHint: 'Tracejado: dois resultados possíveis — ↓ mesmo lado, → vira.',
  analyticsRoadBigSmall: 'Alto / Baixo',
  analyticsRoadOddEven: 'Ímpar / Par',
  analyticsRoadRedBlack: 'Vermelho / Preto',
  analyticsRoadHiLo: 'Alto / Baixo',
  analyticsFairTitle: '% real vs % teórico',
  analyticsFairSample: 'Amostra %n% rodadas · oscilação normal ±%sigma%% por lado (1σ binomial)',
  analyticsFairRoundsCount: '%n% rodadas',
  analyticsFairTheory: 'teórico',
  analyticsFairDesc: 'A linha tracejada marca a posição teórica justa. Diferenças maiores em janelas curtas são variação normal.',
  analyticsFairOddEven: 'Ímpar / Par',
  analyticsFairBigSmall: 'Alto / Baixo',
  analyticsFairRedBlack: 'Vermelho / Preto / Verde',
  analyticsFairHiLo: 'Baixo (1–18) / Alto (19–36)',
  analyticsFairLo: 'Baixo (1–18)',
  analyticsFairHi: 'Alto (19–36)',
  analyticsFairTriple: 'Trinca',
  analyticsDisclaimer: 'Cada rodada é independente · padrões passados não preveem o futuro.',
  odd: 'Ímpar',
  even: 'Par',
  historyReturn: 'Retorno',
  historyRoundBets: '%n% apostas',
  historyScopeAll: 'Todas as salas',
  historyScopeRoom: 'Esta sala · %room%',
  historyScopeTitle: 'Mostrar',
  historyTruncated: 'Mostrando as 100 apostas mais recentes.',
  historySeqDayBreak: 'Rodadas de %d%',
  historyTruncatedRoomHint: 'Filtre por esta sala para ver mais atrás.',
  historyOpenDraw: 'Ver este sorteio',
  historyEmptySeeAll: 'Ver todas as %n%',
  historyLoadError: 'Não foi possível carregar histórico',
  historyFilterAll: 'Todas',
  historyFilterWin: 'Ganhas',
  historyFilterLose: 'Perdidas',
  historyFilterPending: 'Pendentes',
  historyFilterEmpty: 'Nenhuma aposta corresponde a este filtro',
  sheetTop: 'Ranking',
  sheetMyBets: 'Minhas apostas',
  sheetVerify: 'Verificar',
  archiveTitle: 'Histórico de sorteios',
  archiveDesc: 'Todos os sorteios passados · toque em qualquer rodada para verificar a conta',
  archiveEyebrow: 'Arquivo',
  archiveSearchPlaceholder: 'Ir para rodada # do dia (ex.: 47)',
  archiveAll: 'Todos',
  archiveEmpty: 'Nenhuma rodada encontrada. Tente outro número.',
  archiveRoundNotFound: 'Rodada não encontrada.',
  archiveDetailTitle: 'Detalhe da rodada',
  archiveDrawDigits: 'Dígitos D',
  archiveAnchors: 'Blocos Ethereum',
  archiveNoAnchors: 'Âncoras indisponíveis para esta rodada.',
  drawsToday: 'Hoje',
  roundDrawDay: 'Sorteio',
  archiveYesterday: 'Ontem',
  rulesEyebrow: 'Transparência',
  rulesHeader: 'Sorteio justo · Como funciona',
  trustOneLinerLabel: 'EM 1 FRASE',
  trustOneLinerQuote: 'Os números do sorteio vêm do Ethereum, uma rede pública mundial. Ninguém controla — nem a gente.',
  rulesPart1TitleShort: 'De onde vêm os 3 blocos',
  rulesPart1Intro: 'Cada rodada termina nos minutos múltiplos de 5 (00, 05, 10...). A gente pega os 3 PRIMEIROS blocos que a Ethereum fechou logo depois desse momento. Ninguém escolhe — é o próximo da fila pública.',
  rulesExampleHeader: 'Exemplo: Rodada #%round% · %date%',
  rulesLiveHeader: 'Rodada real #%round% · %date% — confira no Etherscan',
  rulesRealTag: 'REAL',
  rulesBlockN: 'Bloco %n%',
  rulesPart1HashLabel: 'Hash completo (toque para verificar no Etherscan):',
  rulesPart1HashHint: 'As letras a-f são puladas — só os dígitos 0-9 contam.',
  rulesPart1ExtractLabel: 'Os 10 ÚLTIMOS dígitos 0-9:',
  rulesBlockExampleTag: 'exemplo',
  rulesPart2TitleShort: 'Como esses números viram D₁..D₁₀',
  rulesPart2Intro: 'Para cada coluna: somamos os 3 valores e ficamos só com o último dígito da soma.',
  rulesPart2SumLabel: 'Soma',
  rulesPart2FoldHint: '↓ guarde só o último dígito',
  rulesPart2ModLabel: '= D',
  rulesPart2ExplainTitle: 'Por que "último dígito"?',
  rulesPart2ExplainBody: 'Quando você divide um número por 10, a sobra é o último dígito dele. Por exemplo: 17 ÷ 10 = 1, sobra 7. Então o último dígito de 17 é 7. Esse atalho tem nome em matemática: chama "mod 10".',
  rulesPart2Sobra: 'sobra',
  rulesPart3TitleShort: 'Como cada jogo usa D₁..D₁₀',
  rulesPart3Intro: 'Os mesmos 10 dígitos viram resultados diferentes em cada jogo. A regra é pública e idêntica em toda rodada.',
  rulesGameLDTitle: 'Último Dígito',
  rulesGameLDRule: 'Regra: usamos APENAS D₁.',
  rulesGameLDD1Note: '← este é o número sorteado',
  rulesGameLDOdd: 'É ímpar → ganha quem apostou ÍMPAR',
  rulesGameLDEven: 'É par → ganha quem apostou PAR',
  rulesGameLDBig: 'Está em 5..9 → ganha quem apostou ALTO',
  rulesGameLDSmall: 'Está em 0..4 → ganha quem apostou BAIXO',
  rulesGameLDExact: 'É exatamente %d% → quem apostou no número %d% ganha (×9,5)',
  rulesGameSicboTitle: 'Sic Bo (3 dados)',
  rulesGameSicboRule: 'Agrupamos os D em 3 trios; cada trio vira um número M de 3 dígitos. O valor do dado é (sobra de M ÷ 6) + 1.',
  rulesGameSicboTrio1: 'M₁ = D₂D₃D₄',
  rulesGameSicboTrio2: 'M₂ = D₅D₆D₇',
  rulesGameSicboTrio3: 'M₃ = D₈D₉D₁₀',
  rulesGameSicboDieLabel: 'Dado',
  rulesGameSicboSumLabel: 'Soma dos 3 dados',
  rulesGameSicboBig: 'Soma 11..17 → ALTO ganha',
  rulesGameSicboSmall: 'Soma 4..10 → BAIXO ganha',
  rulesGameSicboTriple: '3 dados iguais → trinca específica ganha (×180)',
  rulesGameRouletteTitle: 'Roleta (0 a 36)',
  rulesGameRouletteRule: 'Dividimos o número de 10 dígitos por 37. A sobra é a casa sorteada (0 a 36).',
  rulesGameRouletteModLine: '%d% ÷ 37 = %q%, sobra %r% → casa sorteada: %r%',
  rulesGameRouletteHandCheck: 'Conferindo na mão: %parts% = %sum%, e %sum% ÷ 37 deixa a mesma sobra %r%.',
  rulesGameRouletteRed: 'vermelho',
  rulesGameRouletteBlack: 'preto',
  rulesGameRouletteGreen: 'verde (zero)',
  rulesGameRoulettePay1: 'Vermelho/preto, par/ímpar, alto/baixo: paga ×1,95',
  rulesGameRoulettePay2: 'Número exato: paga ×35',
  rulesGameRoulettePay3: 'Dúzia (1-12/13-24/25-36) e coluna (2:1): paga ×3; zero perde',
  rulesGameRoulettePay4: 'Grupos: cavalo ×17 · linha ×11 · quadra ×8 · sextina ×6',
  trustExampleCta: 'Ver mais rodadas no Histórico',
  trustFaqHeader: 'E SE…',
  seeLiveDraws: 'Ver sorteios ao vivo no Sorteia',
  trustFaq1Q: 'E se vocês escolherem qual bloco usar?',
  trustFaq2Q: 'E se a Ethereum cair?',
  trustFaq3Q: 'Vou ganhar — vão pagar mesmo?',
  trustFaq4Q: 'Por que confiar nesse "Ethereum"?',
  trustFaq1A: 'Não dá. A gente espera os PRÓXIMOS 3 blocos depois do horário de fechamento — não escolhemos. Quem chega primeiro vence; não tem como puxar o que favorece a gente.',
  trustFaq2A: 'Aconteceu menos de 1 vez por ano nos últimos 5 anos. Quando cai, a gente espera. Se passar de 30 minutos, sua aposta volta automaticamente pra sua carteira.',
  trustFaq3A: 'Sim. Empresa registrada com CNPJ no Brasil. Depósitos ficam em conta segregada — separados do nosso caixa. Saque via Pix cai em até 1 hora.',
  trustFaq4A: 'Ethereum é a 2ª maior rede pública de blockchain do mundo (a 1ª é o Bitcoin). É usada por bancos, governos e empresas como Nike e Visa. Não é nossa — é pública. Ninguém pode apagar nem mexer.',
  rulesEntryDesc: 'Verifique a matemática dos resultados.',
  trustHeroTitle: 'Você desconfia de site de aposta?',
  trustHeroBody:
    'Pois é. Por isso a gente usa matemática pública: ninguém consegue trapacear — nem a gente.',
  rulesStepAnchorsTitle: 'Fechamento da rodada',
  rulesStepAnchorsBody: 'Depois que a rodada fecha, o sistema espera os 3 primeiros blocos Ethereum que ainda não existiam.',
  rulesStepDigitsTitle: 'Dígitos públicos',
  rulesStepDigitsBody: 'Os hashes desses blocos viram 10 dígitos D. Esse processo é público e repetível.',
  rulesStepGamesTitle: 'Resultados dos jogos',
  rulesStepGamesBody: 'Último Dígito, Sic Bo e Roleta usam os mesmos dígitos D com regras fixas.',
  rulesGameLastDigitBody: 'O primeiro dígito D define o resultado 0-9.',
  rulesGameSicboBody: 'Três dígitos D viram três dados de 1 a 6.',
  rulesGameRouletteBody: 'Três grupos de dígitos formam um número europeu 0-36.',
  rulesOpenArchive: 'Abrir histórico verificável',
  rulesRaffleTitle: 'Sorteio público',
  rulesRaffleIntro: 'Sorteio público em horários fixos. Você participa com bilhetes (não dinheiro).',
  rulesRaffleDesc: 'Cada bilhete vira um número de série na lista pública. No sorteio, os 10 dígitos D₁..D₁₀ da rodada de 5 min escolhem os ganhadores pelo resto de D ÷ N + janela contínua de K nomes.',
  rulesRaffleSourcesHeader: 'Como ganhar bilhetes',
  rulesRaffleSrcDesc_reward_first_deposit: 'Após seu 1º depósito (BRL ≥ R$30), uma vez na vida.',
  rulesRaffleSrcDesc_reward_invite_deposit: 'Quando alguém que você convidou faz o 1º depósito (também ganha 1).',
  rulesRaffleSrcDesc_reward_daily_5rounds: 'Aposte em 5 rodadas diferentes no mesmo dia (mín. R$5 cada).',
  rulesRaffleSrcDesc_reward_3day_streak: 'Aposte 3 dias seguidos sem pular nenhum (mín. R$5/dia).',
  rulesRaffleSrcDesc_reward_first_bet_app: 'Sua 1ª aposta feita pelo APK ou PWA instalado.',
  rulesRaffleNoBuyWarn: 'Bilhetes nunca são vendidos — apenas recompensas. Não transferíveis.',
  rulesRaffleAlgoHeader: 'Detalhes técnicos · Algoritmo (5 linhas)',
  rulesRafflePrizeHeader: 'Estrutura de prêmios',
  rulesRafflePrizeSummary: 'Mín 50 · Máx 100 inscritos · 16 ganhadores · R$ 950 total',
  rulesRaffleEdgeHeader: 'Casos especiais',
  rulesRaffleEdgeVoid: 'Se N < 50 ao final do registro: sorteio cancelado, bilhetes voltam à sua carteira.',
  rulesRaffleEdgeMaxLock: 'Quando N = 100: registros bloqueiam automaticamente.',
  rulesRaffleEdgeExpiry: 'Bilhetes não expiram — valem para sempre.',
  raffleVerifyWindow: 'A janela continua até %n% vencedores.',
  raffleVerifyRound: 'Conferir esta rodada',
  sorteiosTitle: 'Sorteios',
  histLegendWon: 'Ganhou',
  histLegendPlayed: 'Participou',
  histLegendNone: 'Não participou',
  histLegendJackpot: 'Acumulado levado',
  histLegendAria: 'Legenda',
  sorteiosHistNoneRecent: 'Você não participou dos últimos %n% sorteios.',
  milharHistNoneRecent: 'Você não apostou nas últimas %n% rodadas.',
  sorteiosHistTabAll: 'Todos',
  sorteiosHistTabMine: 'Meus sorteios',
  sorteiosMineTickets: '%n% bilhetes',
  sorteiosMineTicketsOne: '1 bilhete',
  sorteiosMineLost: 'Não ganhou',
  sorteiosMineRefunded: 'Reembolsado',
  sorteiosMineSummary: '%e% sorteios · %w% ganhos · %v%',
  sorteiosMineEmpty: 'Você ainda não participou de nenhum sorteio.',
  sorteiosMineEmptyCta: 'Ver o sorteio atual',
  sorteiosMineEnd: 'Esse é o mais antigo.',
  sorteiosMineMoreError: 'Não foi possível carregar mais.',
  sorteiosMineGuest: 'Entre para ver os sorteios de que você participou.',
  sorteiosHistHeadTicket: 'BILHETE',
  sorteiosHistHeadTime: 'HORA',
  sorteiosHistHeadPool: 'PRÊMIOS',
  sorteiosMineHeadStatus: 'SITUAÇÃO',
  sorteiosMineHeadPrize: 'PRÊMIO',
  sorteiosMineStatusWon: 'Ganhou',
  sorteiosMineStatusPending: 'Não sorteado',
  sorteiosHistoryVoidedShort: 'Anulado',
  sorteiosHistoryTitle: 'Histórico',
  sorteiosHistoryEmpty: 'Ainda não há sorteios encerrados.',
  sorteiosHistoryVoided: 'Sem o mínimo de participantes · bilhetes devolvidos',
  sorteiosHistoryVerify: 'Como este sorteio saiu',
  sorteiosHistoryWho: 'Quem participou',
  sorteiosEntriesParticipants: 'Participantes',
  sorteiosEntriesWinners: 'Ganhadores',
  sorteiosEntriesPrizes: 'Em prêmios',
  sorteiosEntriesYou: 'você',
  sorteiosEntriesCountable: 'Esta lista é o N do cálculo — dá para contar.',
  sorteiosVerifyResultTitle: 'O BILHETE SORTEADO',
  sorteiosVerifyResultEntries: '%n% bilhetes participaram',
  sorteiosVerifyWhyTitle: 'POR QUE ESSE',
  sorteiosVerifyDigitsLabel: 'o número público deste sorteio',
  sorteiosVerifyDivide: '÷ %n% bilhetes',
  sorteiosVerifyRemainder: 'resto',
  sorteiosVerifyRemainderIsTicket: 'A sobra já é o bilhete: os bilhetes começam no 000.',
  sorteiosVerifyRemainderIsTicketLegacy: 'Neste sorteio antigo, some 1 ao resto; os bilhetes começam no 001.',
  sorteiosVerifyTicketOffset: '+ 1 → bilhete',
  sorteiosVerifySourceRow: 'De onde vem esse número de 10 dígitos',
  sorteiosVerifySourceHint: 'Três blocos Ethereum · hashes completos · refaça a conta',
  sorteiosVerifyStep1: 'Três blocos públicos de Ethereum',
  sorteiosVerifyStep1Hint: 'De cada bloco tomamos os 10 últimos dígitos. Ninguém escolhe esses blocos.',
  sorteiosVerifyStep2: 'Soma coluna a coluna · fica o último dígito',
  sorteiosVerifyStep4: 'OUTROS PRÊMIOS',
  sorteiosVerifyStep4Hint: 'Passando do último, volta para o 000.',
  sorteiosVerifyStep4HintLegacy: 'Passando do último, volta para o 001.',
  sorteiosVerifyD: 'Número público do sorteio (D)',
  sorteiosVerifyMismatch: 'Não conseguimos reproduzir este número com os dígitos públicos acima.',
  sorteiosVerifyOfficial: 'Registro oficial',
  sorteiosVerifyRecomputed: 'Recalculado nesta página',
  sorteiosAgenda: 'Agenda',
  sorteiosDrawsIn: 'sorteio em',
  sorteiosLastWon: 'Você ganhou %v% 🎉',
  sorteiosLastNone: 'Sem prêmio no seu último sorteio',
  sorteiosLastVoided: 'Último sorteio cancelado · reembolsado',
  sorteiosLastSub: 'Sorteio das %t% · toque para ver como',
  sorteiosTopPrize: 'Prêmio máximo %v% · %n% ganhadores',
  sorteiosHowRow: 'Como funciona',
  sorteiosHowTitle: 'Como funciona',
  sorteiosHowStep1Title: 'Ganhe bilhetes',
  sorteiosHowStep1Body: 'Você não compra bilhetes — ganha jogando e com depósitos.',
  sorteiosHowStep2Title: 'Participe do sorteio',
  sorteiosHowStep2Body: 'Use seus bilhetes para pegar números na rodada do dia.',
  sorteiosHowStep3Title: 'Ganhador justo e verificável',
  sorteiosHowStep3Body: 'O número sai de blocos públicos da blockchain. Ninguém controla — e qualquer um confere.',
  sorteiosHowPrizesTitle: 'Prêmios do sorteio das %t%',
  sorteiosHowPrizeTop: 'Prêmio máximo',
  sorteiosHowPrizeRow: '%n% ganhadores',
  sorteiosHowTotal: '%n% ganhadores no total',
  sorteiosHowEarnCta: 'Como ganhar bilhetes',
  sorteiosHowVerify: 'De onde vem o D · conferir na blockchain',
  fairExampleStep1: '%d% ÷ %n% deixa resto %r% → bilhete %f%',
  fairExampleStep1Legacy: '%d% ÷ %n% deixa resto %r%; some 1 → bilhete %f%',
  fairRank1: '1º',
  fairRank2: '2º',
  fairRank3: '3º',
  sorteiosHowYou: 'você',
  sorteiosHowS1: 'Ao entrar, você pega o próximo número da fila. A numeração começa no 000.',
  sorteiosHowS2: 'Depois que as inscrições fecham, a blockchain gera um número de 10 dígitos. Ninguém controla.',
  sorteiosHowS3: 'A sobra é o bilhete que leva o prêmio máximo.',
  sorteiosHowS3Entries: 'D ÷ %n% inscritos',
  sorteiosHowS3Rem: 'resto %r%',
  sorteiosHowS4: 'Os próximos levam 2º, 3º… Depois do último, volta ao 000.',
  sorteiosMyTicketsFree: 'Grátis · você tem %n% bilhetes',
  sorteiosFreeOdds: 'Grátis · %n% ganham a cada sorteio',
  sorteiosPoolLabel: 'prêmio total',
  sorteiosWinners: '%n% ganhadores',
  sorteiosEntriesLabel: 'Inscritos',
  sorteiosParticipate: 'Participar',
  sorteiosViewNumbers: 'Ver inscritos e meus números',
  sorteiosEarnTickets: 'Ganhar bilhetes',
  sorteiosMyTickets: 'Você tem %n% bilhetes',
  sorteiosTrust: 'Sorteio público · pode conferir',
  sorteiosHowItWorks: 'Como funciona',
  sorteiosNoDraws: 'Sem sorteios programados.',
  sorteiosLoadError: 'Não foi possível carregar os sorteios.',
  sorteiosEmptyHero: 'Nenhum sorteio aberto agora. Veja a agenda acima.',
  sorteiosStatusOpen: 'Aberto',
  sorteiosStatusClosed: 'Encerrado',
  sorteiosStatusOpensAt: 'Abre %t%',
  sorteiosStatusDrawing: 'Sorteando',
  sorteiosStatusVoided: 'Cancelado',
  sorteiosStatusUnavailable: 'Não realizado',
  sorteiosStatusFull: 'Lotado',
  sorteiosFullFlag: 'Lotado · inscrições encerradas',
  sorteiosDrawingFlag: 'Sorteando agora',
  sorteiosResultSoon: 'Resultado em instantes',
  sorteiosAllSeatsTaken: 'Todas as %n% vagas preenchidas',
  sorteiosImIn: 'Você está com %n% números neste sorteio',
  sorteiosImInOne: 'Você está com 1 número neste sorteio',
  sorteiosNotIn: 'Você não entrou neste sorteio',
  sorteiosGuestCta: 'Cadastre-se para ganhar bilhetes',
  sorteiosGuestListFooter: 'Quer seu número nesta lista?',
  sorteiosTicketsKeep: 'Seus %n% bilhetes valem no próximo',
  sorteiosSeeMyNumbers: 'Ver meus números',
  sorteiosNextDrawAt: 'Próximo sorteio às %t%',
  sorteiosNextDrawUnknown: 'Ver a agenda',
  sorteiosLobbyFull: 'Lotado · %v% às %t%',
  sorteiosTomorrowTag: 'Amanhã',
  sorteiosLobbyHint: 'Prêmios grátis todo dia · só com bilhetes',
  sorteiosFreeBadge: 'Grátis',
  sorteiosLobbyNext: 'Próximo às %t% · %v% em prêmios',
  sorteiosPoolTbd: 'prêmio a definir',
  sorteiosMinToRun: 'mínimo %n% inscritos para sortear',
  sorteiosMinReached: 'Mínimo atingido · sorteio confirmado',
  sorteiosNoTicketsYet: 'Você ainda não tem bilhetes para este sorteio',
  sorteiosEarnMore: 'Ganhar mais',
  rulesRaffleFooter: 'D₁..D₁₀ ancorados em 3 blocos Ethereum públicos · resultado verificável a qualquer momento.',
  rulesRaffleAlgoCode:
    'D = D1D2...D10\n' +
    'N = total de inscritos\n' +
    'K = total de prêmios\n' +
    'bilhetes = 000..N-1\n' +
    '1º lugar = D mod N\n' +
    'próximos = janela contínua até K',
  big: 'Alto',
  small: 'Baixo',
  red: 'Vermelho',
  black: 'Preto',
  green: 'Verde',
  notifyType_maintenance: 'Manutenção',
  notifyType_payout: 'Prêmio',
  notifyType_bet: 'Apostas',
  notifyType_private: 'Mensagem',
  notifyType_raffle: 'Sorteio diário',
  notifyType_team_announcement: 'Equipe',
  // ── FAQ: busca, categorias e estados ───────────────────────────────────────
  faqSearchPlaceholder: 'Buscar: saque, pix, quanto paga…',
  faqSearchPlaceholderNoPix: 'Buscar: saque, depósito, quanto paga…',
  faqSearchClear: 'Limpar busca',
  faqResultCount: '%n% resposta(s) encontrada(s)',
  faqEmptyTitle: 'Não achamos nada',
  faqEmptyBody: 'Tente outra palavra — ou pergunte direto pra gente.',
  faqEmptyOtherCategories: 'Existem %n% resposta(s) em outras categorias.',
  faqEmptyCta: 'Falar com o suporte',
  faqCat_all: 'Tudo',
  faqCat_start: 'Começar',
  faqCat_money: 'Dinheiro',
  faqCat_fair: 'Sorteio justo',
  faqCat_games: 'Jogos',
  faqCat_raffle: 'Sorteio diário',
  faqCat_rewards: 'Prêmios',
  faqCat_account: 'Conta',

  // ── FAQ · Começar ──────────────────────────────────────────────────────────
  faq_start_q: 'O que é o Sorteia e como eu começo?',
  faq_start_tldr: 'Aposta com resultado público, tirado da blockchain. Você começa em 4 passos e confere tudo sozinho.',
  faq_start_fig: 'Crie sua conta|Deposite pelo Pix|Escolha uma sala|Faça sua aposta',
  faq_start_fig_nopix: 'Crie sua conta|Deposite por transferência|Escolha uma sala|Faça sua aposta',
  faq_start_points:
    'Cada rodada dura 5 minutos e tem 3 jogos: Último Dígito, Sic Bo e Roleta.|'
    + 'O resultado não sai de um servidor nosso — sai de blocos da rede Ethereum, que é pública e qualquer um lê.|'
    + 'Ganhou, o valor cai na sua carteira sozinho. Você não precisa pedir prêmio nenhum.|'
    + 'Tem também sorteio diário de graça: você entra com bilhete, que se ganha jogando.',
  faq_start_keys: 'comecar|como funciona|iniciante|primeira vez|o que e o sorteia|novato|tutorial|passo a passo|nao entendi nada',
  faq_start_cta: 'Ver as salas',

  faq_app_q: 'Tem aplicativo? Como instalo no celular?',
  faq_app_tldr: 'Tem — é o próprio site. Você adiciona à tela de início e ele abre como app, sem passar por loja.',
  faq_app_fig: 'Abra o Sorteia no navegador|Toque em Adicionar à tela de início|Pronto, abre como app|+1 bilhete',
  faq_app_points:
    'No iPhone: botão Compartilhar → "Adicionar à Tela de Início". No Android: menu ⋮ → "Instalar app".|'
    + 'Ocupa quase nada, abre mais rápido, e você para de perder o Sorteia no meio das abas.|'
    + 'Sua primeira aposta feita pelo app instalado (ou pelo APK) rende 1 bilhete do sorteio.',
  faq_app_keys: 'app|aplicativo|instalar|baixar|apk|pwa|tela de inicio|atalho|download|celular|play store|app store',

  // ── FAQ · Dinheiro ─────────────────────────────────────────────────────────
  faq_deposit_q: 'Quanto tempo demora pra cair meu depósito?',
  faq_deposit_tldr: 'Quase sempre menos de 10 segundos. É Pix: assim que o banco confirma, o saldo aparece.',
  faq_deposit_fig: 'Você paga o Pix|Banco Central confirma|Cai na sua carteira|menos de 10s',
  faq_deposit_points:
    'Só Pix, só em Real (R$). Sem conversão de moeda e sem taxa escondida.|'
    + 'O QR Code e o código Copia e Cola valem por alguns minutos. Se vencer, é só gerar outro.|'
    + 'Pagou e não caiu em 10 minutos? Pegue o comprovante no seu banco e fale com o suporte com ele em mãos.',
  faq_deposit_keys: 'deposito|depositar|pix|qr code|copia e cola|nao caiu|nao entrou|demora|recarregar|colocar dinheiro|adicionar saldo',
  // Sem Pix (todo mercado fora do Brasil): transferência bancária ou QR, na moeda local.
  faq_deposit_tldr_nopix: 'Normalmente em minutos. Assim que o seu banco confirma a transferência, o saldo aparece.',
  faq_deposit_fig_nopix: 'Você faz a transferência|Seu banco confirma|Cai na sua carteira|em minutos',
  faq_deposit_points_nopix:
    'Só transferência bancária ou QR, só na moeda local. Sem conversão de moeda e sem taxa escondida.|'
    + 'Os dados de pagamento valem por alguns minutos. Se expirarem, é só gerar um pedido novo.|'
    + 'Pagou e não caiu em 30 minutos? Pegue o comprovante no seu banco e fale com o suporte com ele em mãos.',
  faq_deposit_nopix_keys: 'deposito|depositar|transferencia|cvu|cbu|qr code|nao caiu|nao entrou|demora|recarregar|colocar dinheiro|adicionar saldo',
  faq_deposit_cta: 'Ir para o depósito',

  faq_withdraw_q: 'Quanto tempo demora o saque?',
  faq_withdraw_tldr: 'Em geral até 1 hora, direto no seu Pix.',
  faq_withdraw_fig: 'Peça o saque na Carteira|A gente confere|Cai no seu Pix|até 1h',
  faq_withdraw_points:
    'A chave Pix precisa estar no seu nome. É sempre a mesma conta que recebe.|'
    + 'Passou de 1 hora? Fale com o suporte e guarde o horário do pedido — com ele a gente acha na hora.|'
    + 'Saque não mexe em aposta: só sai o que já está livre na sua carteira.',
  faq_withdraw_keys: 'saque|sacar|retirar|resgatar|tirar dinheiro|quanto tempo|demora|nao caiu|pix|transferir|levantar',
  faq_withdraw_tldr_nopix: 'Em geral até 1 hora, direto na sua conta bancária.',
  faq_withdraw_fig_nopix: 'Peça o saque na Carteira|A gente confere|Cai na sua conta|até 1h',
  faq_withdraw_points_nopix:
    'A conta de destino precisa estar no seu nome. É sempre a mesma conta que recebe.|'
    + 'Passou de 1 hora? Fale com o suporte e guarde o horário do pedido — com ele a gente acha na hora.|'
    + 'Saque não mexe em aposta: só sai o que já está livre na sua carteira.',
  faq_withdraw_nopix_keys: 'saque|sacar|retirar|resgatar|tirar dinheiro|quanto tempo|demora|nao caiu|transferencia|cvu|cbu|transferir|levantar',
  faq_withdraw_cta: 'Ir para a carteira',

  faq_currencies_q: 'Quais moedas o Sorteia aceita?',
  faq_currencies_tldr: 'Só Real (R$), só por Pix. Sem conversão e sem taxa escondida.',
  faq_currencies_fig: 'Real (R$) pelo Pix|Cripto, dólar, cartão ou boleto',
  faq_currencies_points:
    'O que entra na sua carteira é exatamente o que você aposta — não tem spread nem tarifa no meio do caminho.|'
    + 'Não aceitamos cripto, moeda estrangeira, cartão de crédito nem boleto.|'
    + 'A porta de entrada e a de saída são a mesma: Pix pra depositar, Pix pra sacar.',
  faq_currencies_keys: 'moeda|real|reais|dolar|cripto|bitcoin|usdt|cartao|credito|boleto|pix|pagamento|forma de pagamento|taxa',
  faq_currencies_tldr_nopix: 'Só a moeda local do seu país, só por transferência bancária. Sem conversão e sem taxa escondida.',
  faq_currencies_fig_nopix: 'Moeda local por transferência|Cripto, dólar ou cartão',
  faq_currencies_points_nopix:
    'O que entra na sua carteira é exatamente o que você aposta — não tem spread nem tarifa no meio do caminho.|'
    + 'Não aceitamos cripto, moeda estrangeira nem cartão de crédito.|'
    + 'A porta de entrada e a de saída são a mesma: transferência pra depositar, transferência pra sacar.',
  faq_currencies_nopix_keys: 'moeda|peso|pesos|dolar|cripto|bitcoin|usdt|cartao|credito|transferencia|pagamento|forma de pagamento|taxa',

  faq_prizemissing_q: 'Ganhei mas o prêmio não caiu. E agora?',
  faq_prizemissing_tldr: 'O prêmio cai sozinho quando a rodada sorteia. Se ainda diz "Pendente", é porque ela ainda não saiu.',
  faq_prizemissing_fig:
    'Apostas fecham|Resultado em ~36s|Prêmio cai na carteira|'
    + 'Ainda diz Pendente|Já sorteou e nada caiu|'
    + 'Normal: a rodada ainda não saiu|Abra o histórico e chame o suporte',
  faq_prizemissing_points:
    'Entre o fechamento e o resultado passam uns 36 segundos. Nesse intervalo, Pendente é o esperado.|'
    + 'Assim que a rodada sorteia, o valor entra na carteira automaticamente. Você nunca precisa resgatar.|'
    + 'Se a rodada já saiu e a aposta continua Pendente, abra o Histórico de apostas e mande o número da rodada pro suporte.',
  faq_prizemissing_keys: 'premio|nao caiu|nao recebi|pendente|ganhei|nao creditou|sumiu|cade meu dinheiro|aposta pendente|travada',
  faq_prizemissing_cta: 'Ver histórico de apostas',

  // ── FAQ · Sorteio justo ────────────────────────────────────────────────────
  faq_rigged_q: 'Vocês conseguem manipular o resultado?',
  faq_rigged_tldr: 'Não dá. A gente não escolhe bloco nenhum — pega os 3 primeiros que a Ethereum publicar depois do fechamento.',
  faq_rigged_fig: 'Não escolhemos: valem os 3 primeiros que chegarem',
  faq_rigged_points:
    'A regra é fixa e pública: os 3 primeiros blocos com horário posterior ao fechamento da rodada. Quem chega primeiro, vale.|'
    + 'Ninguém sabe qual vai ser o hash de um bloco antes dele existir — nem nós, nem você, nem a Ethereum.|'
    + 'As apostas fecham 10 segundos antes do corte justamente pra ninguém apostar já sabendo do bloco.|'
    + 'O número de cada bloco usado fica visível: você abre no Etherscan e confere por fora.',
  faq_rigged_keys: 'manipular|roubar|fraude|viciado|honesto|confiavel|justo|golpe|trapaca|enganar|provably fair|e confiavel',
  faq_rigged_cta: 'Ver como o número é calculado',

  faq_calc_q: 'Como o resultado é calculado?',
  faq_calc_tldr: 'Pegamos os 10 últimos dígitos de 3 blocos da Ethereum, somamos coluna a coluna e ficamos com o algarismo final.',
  faq_calc_fig: 'De cada bloco, só os 10 últimos dígitos (aqui mostramos 4)|soma|resto|Isso vira D₁ até D₁₀ — a base dos 3 jogos',
  faq_calc_points:
    'De cada um dos 3 blocos a gente tira só os 10 últimos dígitos do hash.|'
    + 'Soma as três colunas. Passou de 9, fica só o algarismo das unidades: 16 vira 6.|'
    + 'Sobram 10 números de 0 a 9, o D₁ até o D₁₀. Último Dígito usa o D₁; Sic Bo e Roleta usam o resto.|'
    + 'A conta é a mesma pra todo mundo e não depende de nada nosso: com os 3 blocos em mãos, você chega no mesmo resultado.',
  faq_calc_keys: 'como calcula|calculo|conta|hash|bloco|d1|numero|algoritmo|de onde vem|resultado|como sai o numero',
  faq_calc_cta: 'Ver o exemplo completo',

  faq_verify_q: 'Como eu confiro um resultado por conta própria?',
  faq_verify_tldr: 'Cada rodada mostra os 3 blocos que usou. Você abre no Etherscan e compara, sem depender da gente.',
  faq_verify_fig: 'Abra a rodada no histórico|Copie o número do bloco|Compare no Etherscan',
  faq_verify_points:
    'No Histórico, toque numa rodada: ela lista os 3 blocos usados e os dígitos que saíram de cada um.|O Etherscan é um site público de consulta da Ethereum. Não é nosso, e a gente não tem nenhum controle sobre ele.|Confira os 10 últimos dígitos do hash de cada bloco e refaça a soma. Tem que bater.|Se um dia não bater, manda print pro suporte. É exatamente o tipo de erro que a gente quer saber na hora.',
  faq_verify_keys: 'conferir|verificar|auditar|etherscan|prova|desconfio|checar|comprovar|transparencia|bloco|como sei',
  faq_verify_cta: 'Abrir o histórico',

  faq_chainstall_q: 'E se a Ethereum travar e não vier bloco?',
  faq_chainstall_tldr: 'Sem os 3 blocos não tem sorteio: a rodada é anulada e você recebe sua aposta de volta.',
  faq_chainstall_fig:
    'Vieram os 3 blocos|Não vieram os 3|'
    + 'Sorteio normal, uns 36 segundos depois|Rodada anulada e aposta devolvida',
  faq_chainstall_points:
    'Os 3 blocos precisam chegar dentro da janela da rodada. Chegando, o sorteio sai normal — costuma levar uns 36 segundos.|'
    + 'Se os 3 não chegarem, a rodada é ANULADA: ela não vale, e sua aposta volta pra carteira.|'
    + 'Rodada anulada não conta pra nada — nem lucro, nem prejuízo, nem missão.|'
    + 'Não viu o valor de volta em algumas horas? Fale com o suporte com o número da rodada.',
  faq_chainstall_keys: 'travou|caiu|anulada|anulado|void|cancelada|devolucao|estorno|ethereum fora do ar|blockchain caiu|sem resultado',

  // ── FAQ · Jogos ────────────────────────────────────────────────────────────
  faq_lock_q: 'Por que as apostas fecham antes do cronômetro zerar?',
  faq_lock_tldr: 'Elas fecham 10 segundos antes do corte. É proteção contra fraude, não é bug.',
  faq_lock_fig: 'Apostas abertas|Fecha 10s antes|Sorteando',
  faq_lock_points:
    'A rodada dura 5 minutos. O cronômetro que você vê já conta até o fechamento — quando ele zera, fechou de verdade.|'
    + 'Quem produz blocos na Ethereum consegue influenciar os últimos segundos. Fechando 10 segundos antes, essa pessoa teria que apostar sem saber de nada.|'
    + 'Depois disso aparece SORTEANDO, sem cronômetro: a gente está esperando bloco de verdade, o que costuma levar uns 36 segundos.|'
    + 'Se os 3 blocos não chegarem, a rodada é anulada e sua aposta volta pra carteira.',
  faq_lock_keys: 'fechou|fechada|nao consegui apostar|nao consigo apostar|nao da pra apostar|cronometro|tempo|zerou|travou|encerrada|rodada|10 segundos|atrasou|sorteando',

  faq_howtobet_q: 'Como eu aposto, aumento ou tiro uma ficha?',
  faq_howtobet_tldr: 'Escolhe a ficha, toca na posição, confirma. Cada toque empilha mais uma ficha.',
  faq_howtobet_fig: 'Escolha o valor da ficha|Toque na posição|Toque em CONFIRMAR|segure para editar',
  faq_howtobet_points:
    'Quer um valor que não está nas fichas? Toque em "Outro valor" e digite.|Segure a posição (ou toque na ficha dourada) pra abrir Editar: ±, trocar o passo, ou limpar o que ainda não foi confirmado.|Nada é cobrado até você tocar em CONFIRMAR. Antes disso está tudo pendente e dá pra desfazer.|Depois de confirmar não dá pra cancelar: a aposta já entrou na rodada.',
  faq_howtobet_keys: 'apostar|como aposta|ficha|aumentar|diminuir|tirar|cancelar aposta|editar|confirmar|custom|outro valor|valor|desfazer',
  faq_howtobet_cta: 'Ir para as salas',

  faq_betlimits_q: 'Qual é a aposta mínima e a máxima?',
  faq_betlimits_tldr: 'Depende da sala. Cada sala tem o seu teto, e ele aparece no card dela antes de você entrar.',
  faq_betlimits_fig: 'Salas de entrada: teto menor|Salas VIP: teto maior|O valor exato fica no card de cada sala',
  faq_betlimits_points:
    'Salas de entrada têm teto baixo. Salas maiores liberam apostas maiores.|'
    + 'Algumas salas pedem nível VIP. Se o card estiver com cadeado, é isso.|'
    + 'O teto vale por aposta, não por rodada: dá pra ter várias apostas na mesma rodada.|'
    + 'Tentou passar do teto? A aposta é recusada e nada é cobrado.',
  faq_betlimits_keys: 'minimo|maximo|limite|teto|quanto posso apostar|aposta minima|valor minimo|ficha|sala|vip|cap',
  faq_betlimits_cta: 'Comparar as salas',

  faq_rejected_q: 'Por que minha aposta foi recusada?',
  faq_rejected_tldr: 'São sempre três motivos: a rodada fechou, faltou saldo, ou passou do limite da sala.',
  faq_rejected_fig:
    'A rodada já fechou|Saldo insuficiente|Acima do limite da sala|'
    + 'Espere a próxima, abre em segundos|Faça um depósito pelo Pix|Aposte menos ou troque de sala',
  faq_rejected_fig_nopix:
    'A rodada já fechou|Saldo insuficiente|Acima do limite da sala|'
    + 'Espere a próxima, abre em segundos|Faça um depósito|Aposte menos ou troque de sala',
  faq_rejected_points:
    'Recusada quer dizer que nada foi cobrado. Confira o saldo: ele está igualzinho ao de antes da aposta.|'
    + 'Internet ruim é o caso mais comum: você tocou a tempo, mas o toque chegou depois do fechamento.|'
    + 'Cada sala tem seu limite por aposta, e esse limite muda com o nível VIP. O valor aparece no card da sala.',
  faq_rejected_keys: 'recusada|rejeitada|nao aceitou|erro|falhou|nao consegui apostar|nao consigo apostar|nao da pra apostar|sem saldo|saldo insuficiente|limite|nao foi',
  faq_rejected_cta: 'Falar com o suporte',

  faq_history_q: 'Onde vejo minhas apostas e os resultados antigos?',
  faq_history_tldr: 'Em duas telas: o Histórico de apostas mostra o que você fez, e o Histórico de rodadas mostra o que saiu.',
  faq_history_fig: 'Histórico de apostas: o que você apostou e ganhou|Histórico de rodadas: o que saiu em cada sorteio',
  faq_history_points:
    'No Histórico de apostas dá pra ver valor, jogo, rodada e o que foi pago em cada uma.|'
    + 'No Histórico de rodadas qualquer pessoa vê os 3 blocos e os dígitos — inclusive quem nem tem conta.|'
    + 'Toda rodada tem número. É por ele que o suporte acha sua aposta em segundos.',
  faq_history_keys: 'historico|extrato|minhas apostas|resultados|rodadas anteriores|onde vejo|arquivo|antigo|comprovante|passado',
  faq_history_cta: 'Abrir histórico de apostas',

  faq_lastdigit_q: 'Último Dígito: como se joga e quanto paga?',
  faq_lastdigit_tldr: 'Um único dígito, de 0 a 9, decide tudo. Você aposta no tipo dele — ou no número exato.',
  faq_lastdigit_fig: 'Ímpar · Par · Alto · Baixo|Dígito da borda: 9 e 0|Dígito exato (0 a 9)|D₁',
  faq_lastdigit_points:
    'Baixo é 0 a 4. Alto é 5 a 9.|'
    + 'Ímpar, Par, Alto e Baixo pagam ×2 — menos no dígito da borda, que paga ×1,5: o 9 no Ímpar e no Alto, o 0 no Par e no Baixo.|'
    + 'Essa borda existe pra travar o retorno em 95%. Sem ela a conta não fecharia.|'
    + 'Acertar o dígito exato paga ×9,5.',
  faq_lastdigit_keys: 'ultimo digito|last digit|impar|par|alto|baixo|pagamento|premio|odds|quanto paga|d1|numero exato',
  faq_lastdigit_cta: 'Ver o cálculo completo',

  faq_sicbo_q: 'Sic Bo: como se joga e quanto paga?',
  faq_sicbo_tldr: 'Três dados saem dos dígitos da rodada. Você aposta na soma deles, ou em dados específicos.',
  faq_sicbo_fig:
    'Alto (11 a 17) ou Baixo (4 a 10)|Um dado que você escolheu aparece|Trinca exata (ex.: 5-5-5)|Cada dado vem de 3 dígitos da rodada',
  faq_sicbo_points:
    'Ninguém joga dado nenhum: cada dado sai de 3 dígitos da mesma conta pública da rodada.|Alto é soma 11 a 17, Baixo é 4 a 10. Os dois pagam ×1,95 — mas trinca (três dados iguais) anula os dois.|Par ou Ímpar da soma também paga ×1,95.|Escolheu um número de dado: paga ×2 se ele aparecer em 1 dado, ×3 em 2 dados, ×6 nos 3.|Acertar a trinca exata paga ×180.',
  faq_sicbo_keys: 'sicbo|sic bo|dado|dados|alto|baixo|grande|pequeno|trinca|soma|quanto paga|pagamento|odds|tripla',
  faq_sicbo_cta: 'Ver o cálculo completo',

  faq_roulette_q: 'Roleta: como se joga e quanto paga?',
  faq_roulette_tldr: 'Os dígitos da rodada viram uma casa de 0 a 36. Você aposta na cor, na metade, ou no número exato.',
  faq_roulette_fig: 'Vermelho ou Preto|Alto (19-36) ou Baixo (1-18)|Número exato (0 a 36)|Casa sorteada',
  faq_roulette_points:
    'Vermelho/Preto, Par/Ímpar e Alto/Baixo pagam ×1,95 cada. Em todos eles o zero perde.|'
    + 'O zero é verde e não é par, nem ímpar, nem alto, nem baixo. Só ganha quem apostou no próprio 0.|'
    + 'Acertar o número exato paga ×35.',
  faq_roulette_keys: 'roleta|roulette|vermelho|preto|zero|verde|numero|casa|alto|baixo|quanto paga|pagamento|odds',
  faq_roulette_cta: 'Ver o cálculo completo',

  // ── FAQ · Sorteio diário ───────────────────────────────────────────────────
  faq_rafflehow_q: 'Como funciona o sorteio diário?',
  faq_rafflehow_tldr: 'Todo dia, no horário anunciado, 16 pessoas ganham. Você entra com bilhete, não com dinheiro.',
  faq_rafflehow_fig: 'Um prêmio maior|Cinco prêmios médios|Dez prêmios menores',
  faq_rafflehow_points:
    'São R$ 950 no total, divididos em 16 prêmios.|'
    + 'O horário aparece na tela de sorteios, já no seu fuso.|'
    + 'Quem escolhe os ganhadores é o mesmo número público de 10 dígitos que sorteia as rodadas.|'
    + 'Bilhete não se compra: ele se ganha jogando. A próxima resposta lista as cinco formas.',
  faq_rafflehow_keys: 'sorteio|sorteio diario|premio|ganhadores|950|500|horario|como funciona|gratis|raffle|de graca',
  faq_rafflehow_cta: 'Ver os sorteios',

  faq_raffletickets_q: 'Como eu ganho bilhetes do sorteio?',
  faq_raffletickets_tldr: 'São cinco formas, todas de graça. Bilhete nunca é vendido.',
  faq_raffletickets_fig:
    '1º depósito de R$ 30 ou mais|Amigo indicado deposita|5 apostas no mesmo dia|'
    + '3 dias seguidos apostando|1ª aposta pelo app',
  faq_raffletickets_points:
    'A indicação vale 3 bilhetes de uma vez, no momento em que o amigo deposita.|'
    + 'As 5 apostas precisam ser em rodadas diferentes, no mesmo dia.|'
    + 'Bilhete não vence: fica na sua conta até você usar.|'
    + 'Bilhete é seu e não passa pra ninguém: não dá pra transferir nem vender.',
  faq_raffletickets_keys: 'bilhete|bilhetes|como ganhar|gratis|indicar|convidar|amigo|missao|expira|vence|validade|comprar bilhete',
  faq_raffletickets_cta: 'Ver as promoções',

  faq_raffleprize_q: 'Ganhei no sorteio. Onde vejo e como confiro?',
  faq_raffleprize_tldr: 'Cai sozinho na carteira e aparece nos Avisos, junto do número público que escolheu os ganhadores.',
  faq_raffleprize_fig: 'O sorteio roda no horário|O prêmio cai na carteira|Os Avisos mostram o resultado',
  faq_raffleprize_points:
    'Você não precisa estar com o app aberto. O prêmio entra de qualquer jeito.|'
    + 'O aviso traz o número de 10 dígitos usado no sorteio.|'
    + 'Na página do sorteio justo, qualquer pessoa refaz a conta e chega na mesma lista de ganhadores.',
  faq_raffleprize_keys: 'ganhei sorteio|premio sorteio|onde vejo|conferir sorteio|resultado sorteio|ganhador|numero publico',
  faq_raffleprize_cta: 'Ver como o sorteio é justo',

  faq_rafflecancel_q: 'Por que um sorteio foi cancelado?',
  faq_rafflecancel_tldr: 'Faltou gente. Abaixo de 50 inscritos o sorteio não roda, e todos os bilhetes voltam.',
  faq_rafflecancel_fig: 'Menos de 50: não roda|De 50 a 100: roda normal|Chegou a 100, as inscrições fecham sozinhas',
  faq_rafflecancel_points:
    'A regra é 50 inscritos no mínimo e 100 no máximo. Não é decisão de ninguém, é automático.|'
    + 'Se não bater 50 no fechamento, o sorteio é cancelado e o bilhete volta pra você na hora.|'
    + 'Bilhete devolvido volta pra sua conta do mesmo jeito que estava.|'
    + 'Lotou em 100? As inscrições fecham sozinhas e quem já entrou está garantido.',
  faq_rafflecancel_keys: 'cancelado|cancelou|nao rolou|nao aconteceu|devolveu bilhete|50|lotado|cheio|minimo de pessoas|adiado',

  // ── FAQ · Prêmios ──────────────────────────────────────────────────────────
  faq_vip_q: 'O que é o VIP e como eu subo de nível?',
  faq_vip_tldr: 'O nível sobe jogando. Cada nível abre salas novas, tetos maiores e mais bilhetes.',
  faq_vip_fig: 'Salas de entrada|Salas com teto maior|Salas exclusivas e mais bilhetes',
  faq_vip_points:
    'Cada R$ 1 apostado vale 1 ponto de VIP. Nível não se compra.|'
    + 'Card de sala com cadeado quer dizer que ela pede um nível acima do seu.|'
    + 'Alguns bilhetes de sorteio só liberam a partir de certos níveis.|'
    + 'O nível não cai por você ficar um tempo sem jogar.',
  faq_vip_keys: 'vip|nivel|subir de nivel|beneficio|cadeado|sala bloqueada|exclusivo|como sobe|ranking',
  faq_vip_cta: 'Ver meu VIP',

  faq_missions_q: 'Como funcionam as missões, o cashback e os prêmios?',
  faq_missions_tldr: 'Você cumpre a missão, o prêmio entra na Central de Prêmios, e aí é só tocar em resgatar.',
  faq_missions_fig: 'Cumpra a missão|O prêmio entra na Central de Prêmios|Toque em resgatar',
  faq_missions_points:
    'Prêmio não cai sozinho: ele fica esperando você resgatar. Vale dar uma olhada na Central de vez em quando.|'
    + 'São três tipos de prêmio: bilhete de sorteio, dinheiro e cupom de depósito.|'
    + 'Cupom fica na aba Cupons e é usado na hora de depositar, nunca depois.|'
    + 'Prêmio tem prazo. O que está pra vencer aparece primeiro na lista.',
  faq_missions_keys: 'missao|missoes|atividade|promocoes|cashback|premio|resgatar|central de premios|cupom|recompensa|como ganhar|bonus',
  faq_missions_cta: 'Abrir a Central de Prêmios',

  // ── FAQ · Conta ────────────────────────────────────────────────────────────
  faq_password_q: 'Esqueci a senha e não consigo entrar. O que faço?',
  faq_password_tldr: 'Na tela de login, toque em "Esqueci a senha". O código chega no e-mail ou telefone cadastrado.',
  faq_password_fig: 'Toque em Esqueci a senha|Receba o código|Defina a senha nova',
  faq_password_points:
    'O código vale por poucos minutos. Se passar do prazo, peça outro.|'
    + 'Não chegou? Olhe o spam e confirme se o e-mail cadastrado está certo.|'
    + 'Perdeu o acesso ao e-mail e ao telefone: só o suporte resolve, e vai pedir prova de que a conta é sua.|'
    + 'A gente nunca pede sua senha. Ninguém do Sorteia vai te pedir isso, em canal nenhum.',
  faq_password_keys: 'senha|esqueci|nao consigo entrar|login|recuperar|codigo|bloqueado|acesso|entrar na conta|invadiram|hackearam',
  faq_password_cta: 'Ir para segurança',

  faq_limits_q: 'Dá pra limitar quanto eu gasto ou pausar a conta?',
  faq_limits_tldr: 'Dá. Você define um limite diário de perda, liga o lembrete de tempo, ou pausa a conta por um período.',
  faq_limits_fig: 'Limite diário de perda|Lembrete de tempo de jogo|Pausar a conta',
  faq_limits_points:
    'Com o limite diário ligado, a aposta que passaria dele é bloqueada na hora.|'
    + 'Aumentar um limite não vale na hora: leva um tempo pra entrar. Diminuir vale imediatamente.|'
    + 'Durante a pausa você não consegue apostar. O saldo continua seu e o saque segue liberado.|'
    + 'Se o jogo deixou de ser diversão, use a pausa. É exatamente pra isso que ela existe.',
  faq_limits_keys: 'limite|gastar|controlar|parar|pausar|autoexclusao|jogo responsavel|vicio|bloquear conta|tempo de jogo|perda',
  faq_limits_cta: 'Ver meus limites',

  faq_legal_q: 'O Sorteia é legal? Quem está por trás?',
  faq_legal_tldr: 'Empresa registrada no Brasil, só para maiores de 18 anos, com ferramentas de jogo responsável dentro do app.',
  faq_legal_tldr_nopix: 'Empresa registrada, só para maiores de 18 anos, com ferramentas de jogo responsável dentro do app.',
  faq_legal_fig: 'Só para maiores de 18|Empresa registrada no Brasil|Ferramentas de jogo responsável',
  faq_legal_fig_nopix: 'Só para maiores de 18|Empresa registrada|Ferramentas de jogo responsável',
  faq_legal_points:
    'A razão social e o CNPJ ficam no rodapé do site e do app, à vista de todo mundo.|'
    + 'Menor de 18 não pode se cadastrar nem apostar. Isso é lei, não é regra nossa.|'
    + 'Limite de perda, lembrete de tempo e pausa da conta estão em Eu → Limites.|'
    + 'Aposta é entretenimento, não é fonte de renda. Não aposte dinheiro que vai fazer falta.',
  faq_legal_points_nopix:
    'A razão social fica no rodapé do site e do app, à vista de todo mundo.|'
    + 'Menor de 18 não pode se cadastrar nem apostar. Isso é lei, não é regra nossa.|'
    + 'Limite de perda, lembrete de tempo e pausa da conta estão em Eu → Limites.|'
    + 'Aposta é entretenimento, não é fonte de renda. Não aposte dinheiro que vai fazer falta.',
  faq_legal_keys: 'legal|legalizado|autorizado|cnpj|empresa|confiavel|18|menor de idade|golpe|regulamentado|quem e|seguro',
  appUpdateTitle: 'Nova versão disponível',
  appUpdateBody: 'Saiu uma versão nova do app. Atualize pra continuar.',
  appUpdateLater: 'Mais tarde',
  appUpdateNow: 'Atualizar agora',
  appUpdateRefreshing: 'Atualizando...',
  // ---- Milhar / Milhar Hora blocks in the rules page PART 3 ----
  mrulesWindowUnused: 'Nenhuma das duas loterias lê %d%.',
  mrulesWindowNoOverlap: 'As duas faixas não se cruzam — levar o Acumulado de um não faz você levar o do outro.',
  mrulesCadence4: 'A cada 5 min',
  mrulesCadence5: 'A cada hora',
  mrulesThisRoundResult: 'Resultado da rodada %r%',
  mrulesHoraOnTheHour: 'O Milhar da Hora sorteia de hora em hora, sempre na hora cheia — 14:00, 15:00, 16:00. Você aposta até o momento do sorteio. A tabela de prêmios é a mesma; muda o horário.',
  mrulesCompareYours: 'Seu número',
  mrulesCompareDraw: 'Resultado',
  mrulesCompareCountFrom: 'comece por aqui',
  mrulesCompareHits: '%n% em sequência',
  mrulesCompareZero: 'Não acertou',
  mrulesComparePays: 'paga %v%',
  mrulesBreakTitle: 'Acertar no meio não vale nada',
  mrulesBreakBody: 'A conta para no primeiro dígito diferente. Aqui os três primeiros são iguais — mas o último não é, e é por ele que se começa.',
  mrulesPayoutTitle: 'Quanto paga',
  mrulesPayoutHit: 'Acertou',
  mrulesPayoutPays: 'Paga',
  mrulesPayoutDigits: '%n% dígitos',
  mrulesPayoutDigit1: '1 dígito',
  mrulesPayoutJackpotRow: 'todos os %n%',
  mrulesPayoutOn: 'Sobre uma aposta de %v%',
  mrulesLeadTitle: 'As duas loterias',
  mrulesLeadBody: 'Milhar e Milhar da Hora leem a tabela direto: cada um pega uma faixa fixa, na ordem em que os dígitos estão. Nenhuma conta no meio — são os jogos mais fáceis de conferir.',
  mrulesRoomLeadTitle: 'Os jogos da sala',
  mrulesRoomLeadBody: 'Último Dígito, Sic Bo e Roleta usam a mesma tabela, mas fazem uma conta em cima dela. A conta também é pública e igual em toda rodada.',
  mrulesGameRule: 'Regra: o resultado são os dígitos %w%, na ordem. Você escolhe %d% dígitos e confere do último para a esquerda.',
  mrulesSameCheck: 'A conferência é a mesma do Milhar: comece pelo último dígito e vale quantos você acertou em sequência.',
  mrulesMaduroLine: 'MADURO: quando o Acumulado passa de um certo valor, acertar %m% dígitos passa a levar o Acumulado no lugar do prêmio fixo.',
  mrulesAccTitle: 'O Acumulado',
  mrulesAccBody: 'Esse prêmio não é da plataforma: %p% de cada aposta entra nele. Se ninguém acertar todos os dígitos, ele passa inteiro para a próxima rodada e vai crescendo. Quem acertar leva %t% do pote — os outros %s% ficam de semente para começar a próxima.',
  mrulesAccShared: 'Se mais de uma pessoa acertar na mesma rodada, o Acumulado é dividido entre elas. Os outros prêmios não mudam.',
  mrulesConfigUnavailable: 'Não foi possível carregar os prêmios agora.',
  sicboComboDiceHelp: 'Os dois números precisam sair nos 3 dados',
  sicboSingleOddsLine: '×2 / ×3 / ×6 (saiu em 1, 2 ou 3 dados)',
  roulSub18: '18 números · ×1,95',
  roulGreen: 'verde',
  roulColumnN: 'Coluna %n%',
  roulColumn_col1: '1ª coluna',
  roulColumn_col2: '2ª coluna',
  roulColumn_col3: '3ª coluna',
  roulCornerN: 'Quadra %n%',
  chatTeamBadge: 'EQUIPE',
  roundGlobalNumber: 'nº geral %n%',
  otpFieldLabel: 'Código',
  sessionUnknownDevice: 'Outro dispositivo',
  anonPlayerName: 'Jogador',
  wins: 'vitórias',
} as const;
